!(function (e) {
  "function" == typeof define && define.amd ? define("index", e) : e();
})(function () {
  "use strict";
  function e(e, t) {
    if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
  }
  function t(e, t) {
    for (var i = 0; i < t.length; i++) {
      var n = t[i];
      (n.enumerable = n.enumerable || !1),
        (n.configurable = !0),
        "value" in n && (n.writable = !0),
        Object.defineProperty(e, n.key, n);
    }
  }
  function i(e, i, n) {
    return i && t(e.prototype, i), n && t(e, n), e;
  }
  function n(e) {
    return (n = Object.setPrototypeOf
      ? Object.getPrototypeOf
      : function e(t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        })(e);
  }
  function s(e, t) {
    return (s =
      Object.setPrototypeOf ||
      function e(t, i) {
        return (t.__proto__ = i), t;
      })(e, t);
  }
  function a() {
    if (
      "undefined" == typeof Reflect ||
      !Reflect.construct ||
      Reflect.construct.sham
    )
      return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return (
        Boolean.prototype.valueOf.call(
          Reflect.construct(Boolean, [], function () {})
        ),
        !0
      );
    } catch (e) {
      return !1;
    }
  }
  function o(e, t, i) {
    return (o = a()
      ? Reflect.construct
      : function e(t, i, n) {
          var a = [null];
          a.push.apply(a, i);
          var o = new (Function.bind.apply(t, a))();
          return n && s(o, n.prototype), o;
        }).apply(null, arguments);
  }
  function r(e) {
    var t = "function" == typeof Map ? new Map() : void 0;
    return (r = function e(i) {
      var a;
      if (
        null === i ||
        ((a = i), -1 === Function.toString.call(a).indexOf("[native code]"))
      )
        return i;
      if ("function" != typeof i)
        throw TypeError("Super expression must either be null or a function");
      if (void 0 !== t) {
        if (t.has(i)) return t.get(i);
        t.set(i, r);
      }
      function r() {
        return o(i, arguments, n(this).constructor);
      }
      return (
        (r.prototype = Object.create(i.prototype, {
          constructor: {
            value: r,
            enumerable: !1,
            writable: !0,
            configurable: !0,
          },
        })),
        s(r, i)
      );
    })(e);
  }
  var l,
    c,
    h,
    d,
    u,
    p,
    m,
    v = (function () {
      function t() {
        var i = this;
        e(this, t),
          (this.currentBreakpoint = t.getCurrentBreakpoint()),
          window.addEventListener("resize", function () {
            var e = t.getCurrentBreakpoint();
            i.currentBreakpoint !== e &&
              (document.dispatchEvent(
                new CustomEvent("breakpoint:changed", {
                  detail: {
                    previousBreakpoint: i.currentBreakpoint,
                    currentBreakpoint: e,
                  },
                })
              ),
              (i.currentBreakpoint = e));
          });
      }
      return (
        i(t, null, [
          {
            key: "matchesBreakpoint",
            value: function e(t) {
              switch (t) {
                case "phone":
                  return window.matchMedia("screen and (max-width: 640px)")
                    .matches;
                case "tablet":
                  return window.matchMedia(
                    "screen and (min-width: 641px) and (max-width: 1007px)"
                  ).matches;
                case "tablet-and-up":
                  return window.matchMedia("screen and (min-width: 641px)")
                    .matches;
                case "pocket":
                  return window.matchMedia("screen and (max-width: 1007px)")
                    .matches;
                case "lap":
                  return window.matchMedia(
                    "screen and (min-width: 1008px) and (max-width: 1279px)"
                  ).matches;
                case "lap-and-up":
                  return window.matchMedia("screen and (min-width: 1008px)")
                    .matches;
                case "desk":
                  return window.matchMedia("screen and (min-width: 1280px)")
                    .matches;
                case "widescreen":
                  return window.matchMedia("screen and (min-width: 1600px)")
                    .matches;
                case "supports-hover":
                  return window.matchMedia("(hover: hover) and (pointer: fine)")
                    .matches;
              }
            },
          },
          {
            key: "getCurrentBreakpoint",
            value: function e() {
              return window.matchMedia("screen and (max-width: 640px)").matches
                ? "phone"
                : window.matchMedia(
                    "screen and (min-width: 641px) and (max-width: 1007px)"
                  ).matches
                ? "tablet"
                : window.matchMedia(
                    "screen and (min-width: 1008px) and (max-width: 1279px)"
                  ).matches
                ? "lap"
                : window.matchMedia("screen and (min-width: 1280px)").matches
                ? "desk"
                : void 0;
            },
          },
        ]),
        t
      );
    })(),
    f = (function () {
      function t(i) {
        var n =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          s =
            arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        e(this, t),
          (this.element = i),
          (this.initialConfig = Object.assign(
            JSON.parse(i.getAttribute("data-flickity-config")),
            s
          )),
          (this.options = n),
          this._attachListeners(),
          this._build();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              this.flickityInstance.destroy(),
                void 0 !== this.initialConfig.breakpoints &&
                  document.removeEventListener(
                    "breakpoint:changed",
                    this._onBreakpointChangedListener
                  );
            },
          },
          {
            key: "getFlickityInstance",
            value: function e() {
              return this.flickityInstance;
            },
          },
          {
            key: "selectCell",
            value: function e(t) {
              var i =
                  arguments.length > 1 &&
                  void 0 !== arguments[1] &&
                  arguments[1],
                n =
                  !(arguments.length > 2) ||
                  void 0 === arguments[2] ||
                  arguments[2];
              i && this.flickityInstance.pausePlayer(),
                this.flickityInstance.select(t, !1, !n);
            },
          },
          {
            key: "next",
            value: function e() {
              this.flickityInstance.next();
            },
          },
          {
            key: "previous",
            value: function e() {
              this.flickityInstance.previous();
            },
          },
          {
            key: "pausePlayer",
            value: function e() {
              this.flickityInstance.pausePlayer();
            },
          },
          {
            key: "unpausePlayer",
            value: function e() {
              this.flickityInstance.unpausePlayer();
            },
          },
          {
            key: "resize",
            value: function e() {
              this.flickityInstance.resize();
            },
          },
          {
            key: "getSelectedIndex",
            value: function e() {
              return this.flickityInstance.selectedIndex;
            },
          },
          {
            key: "getSelectedCell",
            value: function e() {
              return this.flickityInstance.selectedCell.element;
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              void 0 !== this.initialConfig.breakpoints &&
                ((this._onBreakpointChangedListener =
                  this._onBreakpointChanged.bind(this)),
                document.addEventListener(
                  "breakpoint:changed",
                  this._onBreakpointChangedListener
                ));
            },
          },
          {
            key: "_build",
            value: function e() {
              var t = this,
                i = this._processConfig();
              (this.flickityInstance = new Flickity(this.element, i)),
                this._validateDraggable(),
                (this.selectedIndex = this.flickityInstance.selectedIndex),
                this.flickityInstance.on(
                  "resize",
                  this._validateDraggable.bind(this)
                ),
                this.options.onSelect &&
                  this.flickityInstance.on("select", function () {
                    t.selectedIndex !== t.flickityInstance.selectedIndex &&
                      (t.options.onSelect(
                        t.flickityInstance.selectedIndex,
                        t.flickityInstance.selectedCell.element
                      ),
                      (t.selectedIndex = t.flickityInstance.selectedIndex));
                  }),
                this.options.onSettle &&
                  this.flickityInstance.on("settle", function (e) {
                    t.options.onSettle(
                      e,
                      t.flickityInstance.selectedCell.element
                    );
                  }),
                this.options.onClick &&
                  this.flickityInstance.on(
                    "staticClick",
                    function (e, i, n, s) {
                      t.options.onClick(n, s);
                    }
                  );
            },
          },
          {
            key: "_validateDraggable",
            value: function e() {
              this.flickityInstance.isActive &&
                this.flickityInstance.options.draggable &&
                (void 0 === this.flickityInstance.selectedElements ||
                this.flickityInstance.selectedElements.length ===
                  this.flickityInstance.cells.length
                  ? this.flickityInstance.unbindDrag()
                  : this.flickityInstance.bindDrag());
            },
          },
          {
            key: "_processConfig",
            value: function e() {
              var t = Object.assign({}, this.initialConfig);
              return (delete t.breakpoints,
              void 0 === this.initialConfig.breakpoints)
                ? t
                : (this.initialConfig.breakpoints.forEach(function (e) {
                    v.matchesBreakpoint(e.matches) &&
                      (t = Object.assign(t, e.settings));
                  }),
                  t);
            },
          },
          {
            key: "_onBreakpointChanged",
            value: function e() {
              this.flickityInstance.destroy(), this._build();
            },
          },
        ]),
        t
      );
    })(),
    y = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "slideUp",
            value: function e(t) {
              (t.style.height = "".concat(t.scrollHeight, "px")),
                t.offsetHeight,
                (t.style.height = 0);
            },
          },
          {
            key: "slideDown",
            value: function e(t) {
              if ("auto" !== t.style.height) {
                t.style.height = "".concat(
                  t.firstElementChild.scrollHeight,
                  "px"
                );
                var i = function e(i) {
                  "height" === i.propertyName &&
                    ((t.style.height = "auto"),
                    t.removeEventListener("transitionend", e));
                };
                t.addEventListener("transitionend", i);
              }
            },
          },
        ]),
        t
      );
    })(),
    g = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "getSiblings",
            value: function e(t, i) {
              for (
                var n =
                    arguments.length > 2 &&
                    void 0 !== arguments[2] &&
                    arguments[2],
                  s = [],
                  a = t;
                (a = a.previousElementSibling);

              )
                (!i || a.matches(i)) && s.push(a);
              for (n && s.push(t), a = t; (a = a.nextElementSibling); )
                (!i || a.matches(i)) && s.push(a);
              return s;
            },
          },
          {
            key: "nodeListToArray",
            value: function e(t, i) {
              for (var n = [], s = 0; s !== t.length; ++s)
                (!i || t[s].matches(i)) && n.push(t[s]);
              return n;
            },
          },
          {
            key: "outerWidthWithMargin",
            value: function e(t) {
              var i = t.offsetWidth,
                n = getComputedStyle(t);
              return i + (parseInt(n.marginLeft) + parseInt(n.marginRight));
            },
          },
          {
            key: "outerHeightWithMargin",
            value: function e(t) {
              var i = t.offsetHeight,
                n = getComputedStyle(t);
              return i + (parseInt(n.marginTop) + parseInt(n.marginBottom));
            },
          },
        ]),
        t
      );
    })(),
    b = (function () {
      function t() {
        e(this, t),
          (this.domDelegate = new domDelegate.Delegate(document.body)),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "_attachListeners",
            value: function e() {
              this.domDelegate.on(
                "click",
                '[data-action="toggle-collapsible"]',
                this._toggleCollapsible.bind(this)
              );
            },
          },
          {
            key: "_toggleCollapsible",
            value: function e(t, i) {
              var n = this,
                s = i.closest(".Collapsible");
              !(
                s.classList.contains("Collapsible--autoExpand") &&
                v.matchesBreakpoint("tablet-and-up")
              ) &&
                ("true" === i.getAttribute("aria-expanded")
                  ? this._close(s, i)
                  : this._open(s, i),
                g.getSiblings(s).forEach(function (e) {
                  return n._close(e);
                }),
                t.preventDefault());
            },
          },
          {
            key: "_open",
            value: function e(t) {
              var i = t.querySelector(".Collapsible__Button"),
                n = t.querySelector(".Collapsible__Inner");
              n &&
                "true" !== i.getAttribute("aria-expanded") &&
                (i.setAttribute("aria-expanded", "true"),
                (n.style.overflow = "visible"),
                y.slideDown(n),
                setTimeout(function () {
                  t.style.overflow = "visible";
                }, 350));
            },
          },
          {
            key: "_close",
            value: function e(t) {
              var i = t.querySelector(".Collapsible__Button"),
                n = t.querySelector(".Collapsible__Inner");
              n &&
                "false" !== i.getAttribute("aria-expanded") &&
                (i.setAttribute("aria-expanded", "false"),
                (n.style.overflow = "hidden"),
                (t.style.overflow = "hidden"),
                y.slideUp(n));
            },
          },
        ]),
        t
      );
    })(),
    k = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "trapFocus",
            value: function e(t, i) {
              this.listeners = this.listeners || {};
              var n = t.querySelector("[autofocus]") || t;
              t.setAttribute("tabindex", "-1"),
                n.focus(),
                (this.listeners[i] = function (e) {
                  t === e.target || t.contains(e.target) || t.focus();
                }),
                document.addEventListener("focusin", this.listeners[i]);
            },
          },
          {
            key: "removeTrapFocus",
            value: function e(t, i) {
              t && t.removeAttribute("tabindex"),
                this.listeners &&
                  this.listeners[i] &&
                  document.removeEventListener("focusin", this.listeners[i]);
            },
          },
          {
            key: "clearTrapFocus",
            value: function e() {
              for (var t in this.listeners)
                this.listeners.hasOwnProperty(t) &&
                  document.removeEventListener("focusin", this.listeners[t]);
              this.listeners = {};
            },
          },
        ]),
        t
      );
    })(),
    S = (function () {
      function t(i) {
        var n =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.delegateBody = new domDelegate.Delegate(document.body)),
          (this.onOpen = n.onOpen || function () {}),
          (this.onClose = n.onClose || function () {}),
          (this.isOpen = !1),
          (this.direction = this.element.classList.contains("Drawer--fromLeft")
            ? "fromLeft"
            : "fromRight"),
          (this.pageOverlayElement = document.querySelector(".PageOverlay")),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              this.delegateBody.off(
                "click",
                '[data-action="open-drawer"][data-drawer-id="'.concat(
                  this.element.id,
                  '"]'
                )
              ),
                this.delegateBody.off(
                  "click",
                  '[data-action="close-drawer"][data-drawer-id="'.concat(
                    this.element.id,
                    '"]'
                  )
                ),
                window.removeEventListener(
                  "resize",
                  this._calculateMaxHeightListener
                );
            },
          },
          {
            key: "toggle",
            value: function e() {
              this.isOpen ? this.close() : this.open();
            },
          },
          {
            key: "open",
            value: function e(t) {
              if (!this.isOpen)
                return (
                  this.element.dispatchEvent(
                    new CustomEvent("search:close", { bubbles: !0 })
                  ),
                  t && t.preventDefault(),
                  this.element.setAttribute("aria-hidden", "false"),
                  this._calculateMaxHeight(),
                  document.documentElement.classList.add("no-scroll"),
                  k.trapFocus(this.element, "drawer"),
                  (document.querySelector(
                    "#shopify-section-header"
                  ).style.zIndex = ""),
                  this.pageOverlayElement.classList.add("is-visible"),
                  this.pageOverlayElement.addEventListener(
                    "click",
                    this._closeListener
                  ),
                  (this.isOpen = !0),
                  this.onOpen(),
                  !1
                );
            },
          },
          {
            key: "close",
            value: function e(t) {
              this.isOpen &&
                (t && t.preventDefault(),
                this.element.setAttribute("aria-hidden", "true"),
                document.documentElement.classList.remove("no-scroll"),
                k.removeTrapFocus(this.element, "drawer"),
                this.pageOverlayElement.classList.remove("is-visible"),
                this.pageOverlayElement.removeEventListener(
                  "click",
                  this._closeListener
                ),
                (this.isOpen = !1),
                this.onClose());
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._openListener = this.open.bind(this)),
                (this._closeListener = this.close.bind(this)),
                (this._calculateMaxHeightListener =
                  this._calculateMaxHeight.bind(this)),
                this.delegateBody.on(
                  "click",
                  '[data-action="open-drawer"][data-drawer-id="'.concat(
                    this.element.id,
                    '"]'
                  ),
                  this._openListener
                ),
                this.delegateBody.on(
                  "click",
                  '[data-action="close-drawer"][data-drawer-id="'.concat(
                    this.element.id,
                    '"]'
                  ),
                  this._closeListener
                ),
                this.element.addEventListener(
                  "keyup",
                  this._handleKeyboard.bind(this)
                ),
                window.addEventListener(
                  "resize",
                  this._calculateMaxHeightListener
                );
            },
          },
          {
            key: "_calculateMaxHeight",
            value: function e() {
              this.element.style.maxHeight = window.innerHeight + "px";
            },
          },
          {
            key: "_handleKeyboard",
            value: function e(t) {
              this.isOpen && 27 === t.keyCode && this.close();
            },
          },
        ]),
        t
      );
    })(),
    L = (function () {
      function t() {
        e(this, t),
          (this.element = document.querySelector(".LoadingBar")),
          document.addEventListener(
            "theme:loading:start",
            this._onLoadingStart.bind(this)
          ),
          document.addEventListener(
            "theme:loading:end",
            this._onLoadingEnd.bind(this)
          ),
          this.element.addEventListener(
            "transitionend",
            this._onTransitionEnd.bind(this)
          );
      }
      return (
        i(t, [
          {
            key: "_onLoadingStart",
            value: function e() {
              this.element.classList.add("is-visible"),
                (this.element.style.width = "40%");
            },
          },
          {
            key: "_onLoadingEnd",
            value: function e() {
              (this.element.style.width = "100%"),
                this.element.classList.add("is-finished");
            },
          },
          {
            key: "_onTransitionEnd",
            value: function e(t) {
              "width" === t.propertyName &&
                this.element.classList.contains("is-finished") &&
                (this.element.classList.remove("is-visible"),
                this.element.classList.remove("is-finished"),
                (this.element.style.width = "0"));
            },
          },
        ]),
        t
      );
    })(),
    w = (function () {
      function t() {
        e(this, t),
          (this.domDelegate = new domDelegate.Delegate(document.body)),
          (this.activeModal = null),
          (this.wasLocked = !1),
          (this.pageOverlayElement = document.querySelector(".PageOverlay")),
          this._attachListeners(),
          this._checkOpenByHash();
      }
      return (
        i(t, [
          {
            key: "_attachListeners",
            value: function e() {
              (this._closeListener = this._closeModal.bind(this)),
                (this._handleKeyboardListener =
                  this._handleKeyboard.bind(this)),
                this.domDelegate.on(
                  "click",
                  '[data-action="open-modal"]',
                  this._openModalEvent.bind(this)
                ),
                this.domDelegate.on(
                  "click",
                  '[data-action="close-modal"]',
                  this._closeModal.bind(this)
                );
            },
          },
          {
            key: "_openModalEvent",
            value: function e(t, i) {
              this._openModal(
                document.getElementById(i.getAttribute("aria-controls"))
              ),
                t.preventDefault(),
                t.stopPropagation();
            },
          },
          {
            key: "_openModal",
            value: function e(t) {
              var i = this;
              !this.activeModal &&
                t &&
                ((this.activeModal = t),
                this.domDelegate.on("keyup", this._handleKeyboardListener),
                document.documentElement.classList.contains("no-scroll") &&
                  (this.wasLocked = !0),
                fastdom.mutate(function () {
                  k.clearTrapFocus(),
                    (i._onTransitionEndedListener =
                      i._onTransitionEnded.bind(i)),
                    i.activeModal.addEventListener(
                      "transitionend",
                      i._onTransitionEndedListener
                    ),
                    i.activeModal.setAttribute("aria-hidden", "false"),
                    document.documentElement.classList.add("no-scroll"),
                    i.activeModal.classList.contains("Modal--fullScreen") ||
                      (i.pageOverlayElement.classList.add("is-visible"),
                      i.pageOverlayElement.addEventListener(
                        "click",
                        i._closeListener
                      ));
                }));
            },
          },
          {
            key: "_closeModal",
            value: function e() {
              var t = this;
              this.activeModal &&
                (this.activeModal.removeEventListener(
                  "keyup",
                  this._handleKeyboardListener
                ),
                this.domDelegate.off("keyup"),
                fastdom.mutate(function () {
                  t.activeModal.classList.contains("Modal--videoContent") &&
                    ((t._resetVideoListener = t._resetVideo.bind(t)),
                    t.activeModal.addEventListener(
                      "transitionend",
                      t._resetVideoListener
                    )),
                    k.removeTrapFocus(t.activeModal, "modal"),
                    t.activeModal.classList.contains("Modal--fullScreen") ||
                      (t.pageOverlayElement.classList.remove("is-visible"),
                      t.pageOverlayElement.removeEventListener(
                        "click",
                        t._closeListener
                      )),
                    t.activeModal.setAttribute("aria-hidden", "true"),
                    (t.activeModal = null),
                    t.wasLocked ||
                      document.documentElement.classList.remove("no-scroll");
                }));
            },
          },
          {
            key: "_onTransitionEnded",
            value: function e(t) {
              "visibility" === t.propertyName &&
                (k.trapFocus(this.activeModal, "modal"),
                this.activeModal.removeEventListener(
                  "transitionend",
                  this._onTransitionEndedListener
                ));
            },
          },
          {
            key: "_resetVideo",
            value: function e(t) {
              if ("visibility" === t.propertyName) {
                var i = t.target.querySelector("iframe");
                (i.parentNode.innerHTML =
                  '<iframe class="Image--lazyLoad" data-src='.concat(
                    i.getAttribute("data-src"),
                    ' frameborder="0" allowfullscreen>'
                  )),
                  t.target.removeEventListener(
                    "transitionend",
                    this._resetVideoListener
                  );
              }
            },
          },
          {
            key: "_checkOpenByHash",
            value: function e() {
              var t = window.location.hash,
                i = document.getElementById(t.replace("#", ""));
              i && i.classList.contains("Modal") && this._openModal(i);
            },
          },
          {
            key: "_handleKeyboard",
            value: function e(t) {
              null !== this.activeModal &&
                27 === t.keyCode &&
                this._closeModal();
            },
          },
        ]),
        t
      );
    })(),
    E = (function () {
      function t(i, n) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.activator =
            n.activator ||
            document.querySelector(
              '[aria-controls="'.concat(i.getAttribute("id"), '"]')
            )),
          (this.preferredPosition = n.preferredPosition || "bottom"),
          (this.preferredAlignment = n.preferredAlignment || void 0),
          (this.threshold = n.threshold || 20),
          (this.isOpen = !1),
          (this.onValueChanged = n.onValueChanged || function () {}),
          (this.onOpen = n.onOpen || function () {}),
          (this.onClose = n.onClose || function () {}),
          (this.showOverlay = void 0 === n.showOverlay || n.showOverlay),
          (this.pageOverlayElement = document.querySelector(".PageOverlay")),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              this.element.removeEventListener(
                "keyup",
                this._handleKeyboardListener
              ),
                this.delegateElement.off("click"),
                this.activator.removeEventListener(
                  "click",
                  this._toggleListener
                );
            },
          },
          {
            key: "toggle",
            value: function e() {
              this.isOpen ? this.close() : this.open();
            },
          },
          {
            key: "open",
            value: function e() {
              var t = this;
              !this.isOpen &&
                this.activator.getAttribute("aria-controls") ===
                  this.element.id &&
                (this.element.setAttribute("aria-hidden", "false"),
                this.activator.setAttribute("aria-expanded", "true"),
                disableBodyScroll(!0, "[data-scrollable]"),
                document.documentElement.classList.add("no-scroll"),
                v.matchesBreakpoint("lap-and-up")
                  ? (document.body.addEventListener(
                      "click",
                      this._clickOutsideListener
                    ),
                    this._position(),
                    this.element.setAttribute("tabindex", "-1"),
                    this.element.addEventListener(
                      "transitionend",
                      function () {
                        t.element.focus();
                      },
                      { once: !0 }
                    ))
                  : (this.element.removeAttribute("style"),
                    this.showOverlay &&
                      (this.pageOverlayElement.classList.add("is-visible"),
                      this.pageOverlayElement.addEventListener(
                        "click",
                        this._closeListener
                      ))),
                this.onOpen(this),
                (this.isOpen = !0));
            },
          },
          {
            key: "close",
            value: function e() {
              this.isOpen &&
                (this.element.setAttribute("aria-hidden", "true"),
                this.activator.setAttribute("aria-expanded", "false"),
                disableBodyScroll(!1, "[data-scrollable]"),
                document.documentElement.classList.remove("no-scroll"),
                v.matchesBreakpoint("lap-and-up")
                  ? document.body.removeEventListener(
                      "click",
                      this._clickOutsideListener
                    )
                  : this.showOverlay &&
                    (this.pageOverlayElement.classList.remove("is-visible"),
                    this.pageOverlayElement.removeEventListener(
                      "click",
                      this._closeListener
                    )),
                this.element.removeAttribute("tabindex"),
                this.activator.focus(),
                this.onClose(this),
                (this.isOpen = !1));
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._handleKeyboardListener = this._handleKeyboard.bind(this)),
                (this._clickOutsideListener = this._clickOutside.bind(this)),
                (this._closeListener = this.close.bind(this)),
                (this._toggleListener = this.toggle.bind(this)),
                this.element.addEventListener(
                  "keyup",
                  this._handleKeyboardListener
                ),
                this.activator.addEventListener("click", this._toggleListener),
                this.delegateElement.on(
                  "click",
                  '[data-action="close-popover"]',
                  this.close.bind(this)
                ),
                this.delegateElement.on(
                  "click",
                  '[data-action="select-value"]',
                  this._valueChanged.bind(this)
                ),
                this.element.hasAttribute("id") &&
                  this.delegateElement.on(
                    "focusout",
                    "#".concat(this.element.getAttribute("id")),
                    this._onFocusOut.bind(this)
                  );
            },
          },
          {
            key: "_valueChanged",
            value: function e(t) {
              g.getSiblings(t.target, ".is-selected").forEach(function (e) {
                return e.classList.remove("is-selected");
              }),
                t.target.classList.add("is-selected"),
                this.onValueChanged(
                  t.target.getAttribute("data-value"),
                  t.target,
                  this.activator
                ),
                this.close();
            },
          },
          {
            key: "_onFocusOut",
            value: function e(t) {
              this.element.contains(t.relatedTarget) ||
                t.relatedTarget === this.activator ||
                this.close();
            },
          },
          {
            key: "_clickOutside",
            value: function e(t) {
              t.target.closest(".Popover") ||
                t.target.closest(".Modal") ||
                t.target === this.activator ||
                this.activator.contains(t.target) ||
                this.close();
            },
          },
          {
            key: "_position",
            value: function e() {
              var t = this,
                i = 0,
                n = 0,
                s = "",
                a = "",
                o = this.threshold;
              fastdom.measure(function () {
                var e = window.innerHeight,
                  r = t.activator.getBoundingClientRect(),
                  l = e / 2;
                if ("bottom" === t.preferredPosition)
                  (a = "right"),
                    (s =
                      t.element.clientHeight <= e - (r.bottom + o) ||
                      e - r.bottom >= l
                        ? "bottom"
                        : "top");
                else if ("top" === t.preferredPosition)
                  (a = "right"),
                    (s =
                      t.element.clientHeight <= r.top - o || r.top >= l
                        ? "top"
                        : "bottom");
                else {
                  s = "left";
                  var c = t.element.clientHeight / 2;
                  a =
                    r.top >= c && e - r.bottom >= c
                      ? "center"
                      : e - r.bottom >= c
                      ? "bottom"
                      : "top";
                }
                t.preferredAlignment && (a = t.preferredAlignment),
                  "top" === s
                    ? ((i = r.top - t.element.clientHeight - o),
                      (n =
                        "center" === a
                          ? window.innerWidth -
                            r.right -
                            t.element.clientWidth / 2 +
                            3
                          : window.innerWidth - r.right))
                    : "bottom" === s
                    ? ((i = r.bottom + o),
                      (n =
                        "center" === a
                          ? window.innerWidth -
                            r.right -
                            t.element.clientWidth / 2 +
                            3
                          : window.innerWidth - r.right))
                    : ((n = window.innerWidth - r.left + o),
                      (i =
                        "center" === a
                          ? r.top -
                            t.element.clientHeight / 2 +
                            t.activator.clientHeight / 2
                          : "top" === a
                          ? r.bottom - t.element.clientHeight
                          : r.top));
              }),
                fastdom.mutate(function () {
                  [
                    "Popover--positionBottom",
                    "Popover--positionTop",
                    "Popover--positionCenter",
                    "Popover--alignTop",
                    "Popover--alignCenter",
                    "Popover--alignBottom",
                  ].map(function (e) {
                    return t.element.classList.remove(e);
                  }),
                    t.element.classList.add(
                      "Popover--position".concat(
                        s.charAt(0).toUpperCase() + s.slice(1)
                      )
                    ),
                    t.element.classList.add(
                      "Popover--align".concat(
                        a.charAt(0).toUpperCase() + a.slice(1)
                      )
                    ),
                    t.element.setAttribute(
                      "style",
                      "top: "
                        .concat(parseInt(i), "px; right: ")
                        .concat(parseInt(n), "px;")
                    );
                });
            },
          },
          {
            key: "_handleKeyboard",
            value: function e(t) {
              this.isOpen && 27 === t.keyCode && this.close();
            },
          },
        ]),
        t
      );
    })(),
    I = (function () {
      function t() {
        e(this, t),
          (this.domDelegate = new domDelegate.Delegate(document.body)),
          (this.pageTransition = document.querySelector(".PageTransition")),
          this._attachListeners();
      }
      return (
        i(
          t,
          [
            {
              key: "_attachListeners",
              value: function e() {
                this.domDelegate.on(
                  "click",
                  'a[href]:not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])',
                  this._onPageUnload.bind(this)
                );
              },
            },
            {
              key: "_onPageUnload",
              value: function e(t, i) {
                var n = this;
                if (
                  !t.defaultPrevented &&
                  !t.ctrlKey &&
                  !t.metaKey &&
                  window.theme.showPageTransition &&
                  this.pageTransition &&
                  (t.preventDefault(),
                  window.theme.showPageTransition && this.pageTransition)
                ) {
                  var s = function e(t) {
                    "opacity" === t.propertyName &&
                      (n.pageTransition.removeEventListener("transitionend", e),
                      (window.location.href = i.href));
                  };
                  this.pageTransition.addEventListener("transitionend", s),
                    (this.pageTransition.style.visibility = "visible"),
                    (this.pageTransition.style.opacity = "1");
                }
              },
            },
          ],
          [
            {
              key: "getInstance",
              value: function e() {
                return (
                  this.instance || (this.instance = new t()), this.instance
                );
              },
            },
          ]
        ),
        t
      );
    })(),
    A = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          this.delegateElement.on(
            "change",
            ".ColorSwatch__Radio",
            this._colorChanged.bind(this)
          );
      }
      return (
        i(t, [
          {
            key: "_colorChanged",
            value: function e(t, i) {
              var n = i.closest(".ProductItem"),
                s = i.getAttribute("data-variant-url");
              n
                .querySelector(".ProductItem__ImageWrapper")
                .setAttribute("href", s),
                n
                  .querySelector(".ProductItem__Title > a")
                  .setAttribute("href", s);
              var a = n.querySelector(
                ".ProductItem__Image:not(.ProductItem__Image--alternate)"
              );
              if (
                i.hasAttribute("data-image-url") &&
                i.getAttribute("data-image-id") !==
                  a.getAttribute("data-image-id")
              ) {
                var o = document.createElement("img");
                (o.className =
                  "ProductItem__Image Image--fadeIn Image--lazyLoad"),
                  o.setAttribute(
                    "data-image-id",
                    i.getAttribute("data-image-id")
                  ),
                  o.setAttribute("data-src", i.getAttribute("data-image-url")),
                  o.setAttribute(
                    "data-widths",
                    i.getAttribute("data-image-widths")
                  ),
                  o.setAttribute("data-sizes", "auto"),
                  "natural" === window.theme.productImageSize &&
                    (a.parentNode.style.paddingBottom = "".concat(
                      100 / i.getAttribute("data-image-aspect-ratio"),
                      "%"
                    )),
                  a.parentNode.style.setProperty(
                    "--aspect-ratio",
                    i.getAttribute("data-image-aspect-ratio")
                  ),
                  a.parentNode.replaceChild(o, a);
              }
            },
          },
        ]),
        t
      );
    })(),
    $ = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "getSizedImageUrl",
            value: function e(t, i) {
              if (null === i) return t;
              if ("master" === i) return t.replace(/http(s)?:/, "");
              var n = t.match(
                /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
              );
              if (!n) return null;
              var s = t.split(n[0]),
                a = n[0];
              return (s[0] + "_" + i + a).replace(/http(s)?:/, "");
            },
          },
          {
            key: "getSupportedSizes",
            value: function e(t, i) {
              var n = [],
                s = t.width;
              return (
                i.forEach(function (e) {
                  s >= e && n.push(e);
                }),
                n
              );
            },
          },
        ]),
        t
      );
    })(),
    C = (function () {
      function t(i, n) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.delegateRoot = new domDelegate.Delegate(document.body)),
          (this.slideshow = n),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              this.delegateElement.off("click");
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              this.delegateElement.on(
                "click",
                '[data-action="open-product-zoom"]',
                this._initPhotoSwipe.bind(this)
              ),
                this.delegateElement.on(
                  "click",
                  ".Product__SlideItem--image",
                  this._initPhotoSwipeFromImageClick.bind(this)
                );
            },
          },
          {
            key: "_initPhotoSwipe",
            value: function e() {
              var t = [];
              this.slideshow.flickityInstance.cells.forEach(function (e) {
                e.element.classList.contains("Product__SlideItem--image") &&
                  t.push(e.element.querySelector("img"));
              }),
                this._createPhotoSwipeInstance(
                  this._createPhotoSwipeItemsFromImages(t),
                  parseInt(
                    this.slideshow.flickityInstance.selectedElement.getAttribute(
                      "data-image-media-position"
                    )
                  )
                );
            },
          },
          {
            key: "_initPhotoSwipeFromImageClick",
            value: function e(t, i) {
              if (!v.matchesBreakpoint("pocket")) {
                var n = g.nodeListToArray(
                  this.element.querySelectorAll(
                    ".Product__SlideItem--image img"
                  )
                );
                this._createPhotoSwipeInstance(
                  this._createPhotoSwipeItemsFromImages(n),
                  parseInt(i.getAttribute("data-image-media-position"))
                );
              }
            },
          },
          {
            key: "_createPhotoSwipeItemsFromImages",
            value: function e(t) {
              return t.map(function (e) {
                var t = parseInt(e.getAttribute("data-max-width")),
                  i = parseInt(e.getAttribute("data-max-height")),
                  n = v.matchesBreakpoint("phone") ? 1200 : 1800,
                  s = 1;
                s = t >= i ? Math.max(t / n, 1) : Math.max(i / n, 1);
                var a = Math.floor(t / s),
                  o = Math.floor(i / s);
                return {
                  msrc: e.currentSrc || e.src,
                  w: a,
                  h: o,
                  initialZoomLevel: 0.65,
                  src: $.getSizedImageUrl(
                    e.getAttribute("data-original-src"),
                    a + "x" + o
                  ),
                };
              });
            },
          },
          {
            key: "_createPhotoSwipeInstance",
            value: function e(t, i) {
              var n = this,
                s = document.querySelector(".pswp");
              this.photoSwipeInstance = new PhotoSwipe(s, !1, t, {
                index: i,
                showHideOpacity: !0,
                showAnimationDuration: 500,
                loop: !1,
                history: !1,
                closeOnVerticalDrag: !1,
                allowPanToNext: !1,
                pinchToClose: !1,
                errorMsg:
                  '<p class="pswp__error-msg">' +
                  window.languages.productImageLoadingError +
                  "</p>",
                scaleMode: "zoom",
                getDoubleTapZoom: function e(t, i) {
                  return t ? 1.6 : i.initialZoomLevel < 0.7 ? 1 : 1.33;
                },
                getThumbBoundsFn: function e(t) {
                  var i = n.element.querySelector(
                      '.Product__Slideshow .Carousel__Cell[data-image-media-position="'.concat(
                        parseInt(t),
                        '"] img'
                      )
                    ),
                    s =
                      window.pageYOffset || document.documentElement.scrollTop,
                    a = i.getBoundingClientRect();
                  return { x: a.left, y: a.top + s, w: a.width };
                },
              });
              var a = this.photoSwipeInstance.updateSize,
                o = null;
              (this.photoSwipeInstance.updateSize = function () {
                (null === o || o !== window.innerWidth) && a(this, arguments),
                  (o = window.innerWidth);
              }),
                this.photoSwipeInstance.listen(
                  "beforeChange",
                  this._onSlideChanged.bind(this)
                ),
                this.photoSwipeInstance.listen(
                  "destroy",
                  this._destroyPhotoSwipe.bind(this)
                ),
                this.photoSwipeInstance.listen(
                  "doubleTap",
                  this._onDoubleTap.bind(this)
                ),
                this.photoSwipeInstance.listen(
                  "initialZoomIn",
                  this._onInitialZoomIn.bind(this)
                ),
                this.photoSwipeInstance.listen(
                  "initialZoomOut",
                  this._onInitialZoomOut.bind(this)
                ),
                this.delegateRoot.on(
                  "pswpTap",
                  ".pswp__scroll-wrap",
                  this._onSingleTap.bind(this)
                ),
                this.delegateRoot.on(
                  "pswpTap",
                  ".pswp__button--close",
                  this.photoSwipeInstance.close
                ),
                this.delegateRoot.on(
                  "pswpTap",
                  ".pswp__button--prev",
                  this.photoSwipeInstance.prev
                ),
                this.delegateRoot.on(
                  "pswpTap",
                  ".pswp__button--next",
                  this.photoSwipeInstance.next
                ),
                this.photoSwipeInstance.init();
            },
          },
          {
            key: "_onSlideChanged",
            value: function e() {
              0 === this.photoSwipeInstance.getCurrentIndex()
                ? this.photoSwipeInstance.scrollWrap
                    .querySelector(".pswp__button--prev")
                    .setAttribute("disabled", "disabled")
                : this.photoSwipeInstance.scrollWrap
                    .querySelector(".pswp__button--prev")
                    .removeAttribute("disabled"),
                this.photoSwipeInstance.getCurrentIndex() + 1 ===
                this.photoSwipeInstance.options.getNumItemsFn()
                  ? this.photoSwipeInstance.scrollWrap
                      .querySelector(".pswp__button--next")
                      .setAttribute("disabled", "disabled")
                  : this.photoSwipeInstance.scrollWrap
                      .querySelector(".pswp__button--next")
                      .removeAttribute("disabled");
            },
          },
          {
            key: "_onSingleTap",
            value: function e(t) {
              t.detail && "mouse" !== t.detail.pointerType
                ? !t.target.classList.contains("pswp__button") &&
                  t.target
                    .closest(".pswp")
                    .querySelector(".pswp__ui")
                    .classList.toggle("pswp__ui--hidden")
                : t.target.classList.contains("pswp__img") &&
                  this.photoSwipeInstance.toggleDesktopZoom(
                    t.detail.releasePoint
                  );
            },
          },
          {
            key: "_onDoubleTap",
            value: function e(t) {
              var i = this.photoSwipeInstance.currItem.initialZoomLevel;
              this.photoSwipeInstance.getZoomLevel() !== i
                ? this.photoSwipeInstance.zoomTo(i, t, 333)
                : this.photoSwipeInstance.zoomTo(i < 0.7 ? 1 : 1.33, t, 333);
            },
          },
          {
            key: "_onInitialZoomIn",
            value: function e() {
              document
                .querySelector(".pswp__ui")
                .classList.remove("pswp__ui--hidden");
            },
          },
          {
            key: "_onInitialZoomOut",
            value: function e() {
              document
                .querySelector(".pswp__ui")
                .classList.add("pswp__ui--hidden");
            },
          },
          {
            key: "_destroyPhotoSwipe",
            value: function e() {
              this.delegateRoot.off("pswpTap"),
                (this.photoSwipeInstance = null);
            },
          },
        ]),
        t
      );
    })(),
    P = (function () {
      function t(i, n) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.delegateRoot = new domDelegate.Delegate(
            document.documentElement
          )),
          (this.stackProductImages = n),
          this._attachListeners();
        var s = document.createElement("link");
        (s.rel = "stylesheet"),
          (s.href =
            "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"),
          document.head.appendChild(s),
          window.Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: this._setupModelViewerUI.bind(this),
            },
            { name: "shopify-xr", version: "1.0" },
          ]);
      }
      return (
        i(t, [
          { key: "destroy", value: function e() {} },
          {
            key: "_attachListeners",
            value: function e() {
              var t = this;
              this.element
                .querySelector("model-viewer")
                .addEventListener(
                  "shopify_model_viewer_ui_toggle_play",
                  function () {
                    t.element.dispatchEvent(
                      new CustomEvent("model:played", { bubbles: !0 })
                    );
                  }
                ),
                this.element
                  .querySelector("model-viewer")
                  .addEventListener(
                    "shopify_model_viewer_ui_toggle_pause",
                    function () {
                      t.element.dispatchEvent(
                        new CustomEvent("model:paused", { bubbles: !0 })
                      );
                    }
                  );
            },
          },
          {
            key: "hasBeenSelected",
            value: function e() {
              v.matchesBreakpoint("supports-hover") && this.modelUi.play();
            },
          },
          {
            key: "hasBeenDeselected",
            value: function e() {
              this.modelUi.pause();
            },
          },
          {
            key: "_setupModelViewerUI",
            value: function e() {
              (this.modelElement = this.element.querySelector("model-viewer")),
                (this.modelUi = new window.Shopify.ModelViewerUI(
                  this.modelElement
                ));
            },
          },
        ]),
        t
      );
    })(),
    T = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          this.delegateElement.on(
            "click",
            ".spr-summary-actions-newreview",
            this._onNewReviewClicked.bind(this)
          ),
          (window.SPRCallbacks = {}),
          (window.SPRCallbacks.onFormSuccess = this._onFormSuccess.bind(this)),
          (window.SPRCallbacks.onReviewsLoad = this._onReviewsLoad.bind(this));
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              this.delegateElement.off();
            },
          },
          {
            key: "_updatePagination",
            value: function e(t, i) {
              SPR.$(i).data("page", parseInt(i.getAttribute("data-page")) + 1);
            },
          },
          {
            key: "_onFormSuccess",
            value: function e() {
              var t = this.element.querySelector(".spr-form-message-success");
              window.scrollTo(0, t.offsetTop - 45);
            },
          },
          {
            key: "_onReviewsLoad",
            value: function e() {
              var t = this.element.querySelector(".spr-summary-actions"),
                i = t.querySelector(".spr-pagination-next"),
                n = this.element.querySelector(
                  ".spr-pagination .spr-pagination-next"
                );
              i && i.remove(), n && t.insertBefore(n, t.firstChild);
            },
          },
          {
            key: "_onNewReviewClicked",
            value: function e(t, i) {
              (i.style.display = "none"),
                i.previousElementSibling &&
                  (i.previousElementSibling.style.display = "none");
            },
          },
        ]),
        t
      );
    })(),
    _ = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "serialize",
            value: function e(i) {
              function n(e, t) {
                var i = e.lastIndexOf("[");
                if (-1 === i) {
                  var s = {};
                  return (s[e] = t), s;
                }
                var a = e.substr(0, i),
                  o = {};
                return (o[e.substring(i + 1, e.length - 1)] = t), n(a, o);
              }
              for (var s = {}, a = 0, o = i.elements.length; a < o; a++) {
                var r = i.elements[a];
                if (
                  "" !== r.name &&
                  !r.disabled &&
                  r.name &&
                  !r.disabled &&
                  (r.checked ||
                    /select|textarea/i.test(r.nodeName) ||
                    /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
                      r.type
                    ))
                ) {
                  var l = n(r.name, r.value);
                  s = t.extend(s, l);
                }
              }
              return s;
            },
          },
          {
            key: "extend",
            value: function e() {
              for (var i = {}, n = 0; n < arguments.length; n++)
                !(function e(n) {
                  for (var s in n)
                    n.hasOwnProperty(s) &&
                      ("[object Object]" ===
                      Object.prototype.toString.call(n[s])
                        ? (i[s] = t.extend(i[s], n[s]))
                        : (i[s] = n[s]));
                })(arguments[n]);
              return i;
            },
          },
        ]),
        t
      );
    })(),
    x = (function () {
      function t() {
        e(this, t);
      }
      return (
        i(t, null, [
          {
            key: "formatMoney",
            value: function e(t, i) {
              "string" == typeof t && (t = t.replace(".", ""));
              var n = /\{\{\s*(\w+)\s*\}\}/,
                s = i || "${{amount}}";
              function a(e, t) {
                return null == e || e != e ? t : e;
              }
              function o(e, t, i, n) {
                if (
                  ((t = a(t, 2)),
                  (i = a(i, ",")),
                  (n = a(n, ".")),
                  isNaN(e) || null == e)
                )
                  return 0;
                var s,
                  o = (e = (e / 100).toFixed(t)).split(".");
                return (
                  o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
                  (o[1] ? n + o[1] : "")
                );
              }
              var r = "";
              switch (s.match(n)[1]) {
                case "amount":
                  r = o(t, 2);
                  break;
                case "amount_no_decimals":
                  r = o(t, 0);
                  break;
                case "amount_with_space_separator":
                  r = o(t, 2, " ", ".");
                  break;
                case "amount_no_decimals_with_comma_separator":
                  r = o(t, 0, ".", ",");
                  break;
                case "amount_no_decimals_with_space_separator":
                  r = o(t, 0, " ");
                  break;
                case "amount_with_comma_separator":
                  r = o(t, 2, ".", ",");
              }
              return -1 !== s.indexOf("with_comma_separator")
                ? s.replace(n, r).replace(",00", "")
                : s.replace(n, r).replace(".00", "");
            },
          },
        ]),
        t
      );
    })(),
    q = (function () {
      function t(i, n) {
        var s =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        e(this, t),
          (this.element = i),
          (this.parentProductVariants = n),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.activator =
            s.activator ||
            document.querySelector(
              '[aria-controls="'.concat(i.getAttribute("id"), '"]')
            )),
          (this.onValueChangedCallback = s.onValueChanged || function () {}),
          (this.isOpen = !1),
          (this.pageOverlayElement = document.querySelector(".PageOverlay")),
          (this.variantChoiceList = g.nodeListToArray(
            this.element.querySelectorAll(".VariantSelector__Choice")
          )),
          (this.variantCarousel = new f(
            this.element.querySelector(".VariantSelector__Carousel"),
            {
              onSelect: this._variantChanged.bind(this),
              onClick: this._variantSelected.bind(this),
            }
          )),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              this.element.removeEventListener(
                "keyup",
                this._handleKeyboardListener
              ),
                this.delegateElement.off("click"),
                this.activator.removeEventListener(
                  "click",
                  this._toggleListener
                ),
                this.variantCarousel.destroy();
            },
          },
          {
            key: "toggle",
            value: function e() {
              this.isOpen ? this.close() : this.open();
            },
          },
          {
            key: "open",
            value: function e() {
              !this.isOpen &&
                (this.element.setAttribute("aria-hidden", "false"),
                this.activator.setAttribute("aria-expanded", "true"),
                k.trapFocus(this.element, "variant-selector"),
                document.documentElement.classList.add("no-scroll"),
                this.element.setAttribute("style", ""),
                this.pageOverlayElement.classList.add("is-visible"),
                this.pageOverlayElement.addEventListener(
                  "click",
                  this._closeListener
                ),
                (this.isOpen = !0));
            },
          },
          {
            key: "close",
            value: function e() {
              this.isOpen &&
                (this.element.setAttribute("aria-hidden", "true"),
                this.activator.setAttribute("aria-expanded", "false"),
                k.removeTrapFocus(this.element, "variant-selector"),
                document.documentElement.classList.remove("no-scroll"),
                this.pageOverlayElement.classList.remove("is-visible"),
                this.pageOverlayElement.removeEventListener(
                  "click",
                  this._closeListener
                ),
                (this.isOpen = !1));
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._handleKeyboardListener = this._handleKeyboard.bind(this)),
                (this._closeListener = this.close.bind(this)),
                (this._toggleListener = this.toggle.bind(this)),
                this.element.addEventListener(
                  "keyup",
                  this._handleKeyboardListener
                ),
                this.activator.addEventListener("click", this._toggleListener),
                this.delegateElement.on(
                  "click",
                  '[data-action="select-variant"]',
                  this._onVariantSelect.bind(this)
                ),
                this.parentProductVariants.delegateElement.on(
                  "variant:changed",
                  this._onVariantChanged.bind(this)
                );
            },
          },
          {
            key: "_variantChanged",
            value: function e(t) {
              var i = this.variantChoiceList[t];
              i.classList.add("is-selected"),
                g.getSiblings(i, ".is-selected").forEach(function (e) {
                  return e.classList.remove("is-selected");
                });
            },
          },
          {
            key: "_variantSelected",
            value: function e(t, i) {
              this.variantCarousel.getSelectedIndex() === i
                ? (this.onValueChangedCallback(
                    t.getAttribute("data-option-value"),
                    t,
                    this.activator
                  ),
                  this.close())
                : this.variantCarousel.selectCell(i);
            },
          },
          {
            key: "_onVariantChanged",
            value: function e(t) {
              var i = this,
                n = t.detail.variant,
                s = this.element.querySelectorAll(
                  ".VariantSelector__ImageWrapper"
                ),
                a = !1;
              g.nodeListToArray(s).forEach(function (e) {
                var t =
                    parseInt(
                      e.parentElement.getAttribute("data-option-position")
                    ) - 1,
                  i = "";
                n.options.forEach(function (e, n) {
                  n !== t && (i += e);
                }),
                  e.getAttribute("data-variant-title") === i
                    ? (e.setAttribute("aria-hidden", "false"), (a = !0))
                    : e.setAttribute("aria-hidden", "true");
              }),
                a || s.children[0].setAttribute("aria-hidden", "false");
              var o = 0;
              g.nodeListToArray(
                this.element.querySelectorAll(".VariantSelector__ChoicePrice")
              ).forEach(function (e, t) {
                var s = parseInt(e.getAttribute("data-color-position")) - 1;
                i.parentProductVariants.productData.variants.forEach(function (
                  i
                ) {
                  var a = !0;
                  i.options.forEach(function (e, t) {
                    t !== s && i.options[t] !== n.options[t] && (a = !1);
                  }),
                    a &&
                      i.options[s] === n.options[s] &&
                      o++ === t &&
                      (e.innerHTML =
                        '<span class="Heading Text--subdued">'.concat(
                          x.formatMoney(i.price, window.theme.moneyFormat),
                          "</span>"
                        ));
                });
              });
            },
          },
          {
            key: "_onVariantSelect",
            value: function e() {
              var t =
                this.variantCarousel.flickityInstance.selectedCell.element;
              this.onValueChangedCallback(
                t.getAttribute("data-option-value"),
                t,
                this.activator
              ),
                this.close();
            },
          },
          {
            key: "_handleKeyboard",
            value: function e(t) {
              this.isOpen && 27 === t.keyCode && this.close();
            },
          },
        ]),
        t
      );
    })(),
    M = (function () {
      function t(i, n) {
        e(this, t),
          (this.element = i),
          (this.productTitle = n),
          (this.existingDrawers = {});
      }
      return (
        i(t, [
          {
            key: "updateWithVariant",
            value: function e(t) {
              if (this.element) {
                if (!t) {
                  this.element.textContent = "";
                  return;
                }
                this._renderAvailabilitySection(t.id);
              }
            },
          },
          {
            key: "_renderAvailabilitySection",
            value: function e(t) {
              var i = this;
              this.element.innerHTML = "";
              var n = document.getElementById(
                "StoreAvailabilityModal-".concat(t)
              );
              return (
                n && n.remove(),
                this.existingDrawers["StoreAvailabilityModal-".concat(t)] &&
                  (this.existingDrawers[
                    "StoreAvailabilityModal-".concat(t)
                  ].destroy(),
                  delete this.existingDrawers[
                    "StoreAvailabilityModal-".concat(t)
                  ]),
                fetch(
                  ""
                    .concat(window.routes.rootUrlWithoutSlash, "/variants/")
                    .concat(t, "?section_id=store-availability")
                ).then(function (e) {
                  return e.text().then(function (e) {
                    (i.element.innerHTML = e),
                      (i.element.innerHTML =
                        i.element.firstElementChild.innerHTML);
                    var n = i.element.querySelector(
                      ".store-availabilities-modal__product-title"
                    );
                    n && (n.textContent = i.productTitle);
                    var s = document.getElementById(
                      "StoreAvailabilityModal-".concat(t)
                    );
                    document.body.appendChild(s),
                      (i.existingDrawers["StoreAvailabilityModal-".concat(t)] =
                        new S(s));
                  });
                })
              );
            },
          },
        ]),
        t
      );
    })(),
    H = (function () {
      function t(i, n) {
        var s = this;
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = n);
        var a = JSON.parse(
          this.element.querySelector("[data-product-json]").innerHTML
        );
        (this.productData = a.product),
          (this.variantsInventories = a.inventories || {}),
          (this.masterSelector = this.element.querySelector(
            "#product-select-".concat(this.productData.id)
          )),
          this.productData.variants.forEach(function (e) {
            e.id === a.selected_variant_id &&
              ((s.currentVariant = e),
              (s.option1 = e.option1),
              (s.option2 = e.option2),
              (s.option3 = e.option3));
          }),
          (this.storeAvailability = new M(
            this.element.querySelector(
              ".ProductMeta__StoreAvailabilityContainer"
            ),
            this.productData.title
          )),
          this.storeAvailability.updateWithVariant(this.currentVariant),
          this._attachListeners(),
          this._createSelectors();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              this.delegateElement.off("click"),
                this.formPopovers.forEach(function (e) {
                  return e.destroy();
                }),
                this.formVariantSelectors.forEach(function (e) {
                  return e.destroy();
                });
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              this.delegateElement.on(
                "click",
                '[data-action="add-to-cart"]',
                this._addToCart.bind(this)
              ),
                this.delegateElement.on(
                  "click",
                  '[data-action="decrease-quantity"]',
                  this._decreaseQuantity.bind(this)
                ),
                this.delegateElement.on(
                  "click",
                  '[data-action="increase-quantity"]',
                  this._increaseQuantity.bind(this)
                ),
                this.delegateElement.on(
                  "change",
                  '[name="quantity"]',
                  this._validateQuantity.bind(this)
                ),
                this.delegateElement.on(
                  "change",
                  '.ProductForm__Option [type="radio"]',
                  this._onOptionChanged.bind(this)
                );
            },
          },
          {
            key: "_createSelectors",
            value: function e() {
              var t = this;
              (this.formPopovers = []),
                (this.formVariantSelectors = []),
                g
                  .nodeListToArray(
                    this.element.querySelectorAll(".OptionSelector")
                  )
                  .forEach(function (e) {
                    var i = new E(e, {
                      preferredPosition: "left",
                      onValueChanged: t._onOptionChanged.bind(t),
                    });
                    t.formPopovers.push(i);
                  }),
                g
                  .nodeListToArray(
                    this.element.querySelectorAll(".VariantSelector")
                  )
                  .forEach(function (e) {
                    var i = new q(e, t, {
                      onValueChanged: t._onOptionChanged.bind(t),
                    });
                    t.formVariantSelectors.push(i);
                  });
            },
          },
          {
            key: "_onVariantChanged",
            value: function e(t, i) {
              this._updateProductPrices(i, t),
                this._updateInventory(i, t),
                this._updateSku(i, t),
                this._updateUnitPrice(i, t),
                this._updateAddToCartButton(i, t),
                this.storeAvailability.updateWithVariant(i),
                this.element.dispatchEvent(
                  new CustomEvent("variant:changed", {
                    bubbles: !0,
                    detail: { variant: i, previousVariant: t },
                  })
                );
            },
          },
          {
            key: "_updateProductPrices",
            value: function e(t, i) {
              var n = this.element.querySelector(".ProductMeta__PriceList"),
                s = window.theme.currencyCodeEnabled
                  ? window.theme.moneyWithCurrencyFormat
                  : window.theme.moneyFormat;
              if (n) {
                if (t) {
                  if (
                    i &&
                    i.price === t.price &&
                    i.compare_at_price === t.compare_at_price
                  )
                    return;
                  (n.innerHTML = ""),
                    t.compare_at_price > t.price
                      ? ((n.innerHTML +=
                          '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>'.concat(
                            x.formatMoney(t.price, s),
                            "</span>"
                          )),
                        (n.innerHTML +=
                          '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>'.concat(
                            x.formatMoney(t.compare_at_price, s),
                            "</span>"
                          )))
                      : (n.innerHTML +=
                          '<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>'.concat(
                            x.formatMoney(t.price, s),
                            "</span>"
                          )),
                    (n.style.display = "");
                } else n.style.display = "none";
              }
            },
          },
          {
            key: "_updateInventory",
            value: function e(t) {
              if (this.options.showInventoryQuantity) {
                var i = this.element.querySelector(".ProductForm__Inventory"),
                  n = t ? this.variantsInventories[t.id] : null;
                !t ||
                null === n.inventory_management ||
                n.inventory_quantity <= 0 ||
                (this.options.inventoryQuantityThreshold > 0 &&
                  n.inventory_quantity >
                    this.options.inventoryQuantityThreshold)
                  ? (i.style.display = "none")
                  : ((i.innerHTML = n.inventory_message),
                    (i.style.display = ""));
              }
            },
          },
          {
            key: "_updateSku",
            value: function e(t) {
              if (this.options.showSku && t) {
                var i = this.element.querySelector(".ProductMeta__SkuNumber");
                i && t.sku && (i.innerText = t.sku);
              }
            },
          },
          {
            key: "_updateUnitPrice",
            value: function e(t) {
              if (t) {
                var i = this.element.querySelector(
                  ".ProductMeta__UnitPriceMeasurement"
                );
                if (i) {
                  if (!t.hasOwnProperty("unit_price")) {
                    i.style.display = "none";
                    return;
                  }
                  (i.style.display = "block"),
                    (i.querySelector(".UnitPriceMeasurement__Price").innerHTML =
                      x.formatMoney(t.unit_price, window.theme.moneyFormat)),
                    (i.querySelector(
                      ".UnitPriceMeasurement__ReferenceUnit"
                    ).textContent = t.unit_price_measurement.reference_unit);
                  var n = i.querySelector(
                    ".UnitPriceMeasurement__ReferenceValue"
                  );
                  (n.textContent = t.unit_price_measurement.reference_value),
                    (n.style.display =
                      1 === t.unit_price_measurement.reference_value
                        ? "none"
                        : "inline");
                }
              }
            },
          },
          {
            key: "_updateAddToCartButton",
            value: function e(t) {
              var i = this.element.querySelector(".ProductForm__AddToCart"),
                n = this.element.querySelector(".shopify-payment-button");
              i &&
                (i.classList.remove("Button--secondary"),
                i.classList.remove("Button--primary"),
                t
                  ? t.available
                    ? (i.removeAttribute("disabled"),
                      i.classList.add(
                        "true" === i.getAttribute("data-use-primary-button")
                          ? "Button--primary"
                          : "Button--secondary"
                      ),
                      i.setAttribute("data-action", "add-to-cart"),
                      void 0 === this.options.showPriceInButton ||
                      this.options.showPriceInButton
                        ? (i.innerHTML = "\n            <span>"
                            .concat(
                              window.languages.productFormAddToCart,
                              '</span>\n            <span class="Button__SeparatorDot"></span>\n            <span data-money-convertible>'
                            )
                            .concat(
                              x.formatMoney(t.price, window.theme.moneyFormat),
                              "</span>\n          "
                            ))
                        : (i.innerHTML = "<span>".concat(
                            window.languages.productFormAddToCart,
                            "</span>"
                          )))
                    : (i.setAttribute("disabled", "disabled"),
                      i.classList.add("Button--secondary"),
                      i.removeAttribute("data-action"),
                      (i.innerHTML = window.languages.productFormSoldOut))
                  : (i.setAttribute("disabled", "disabled"),
                    i.removeAttribute("data-action"),
                    i.classList.add("Button--secondary"),
                    (i.innerHTML = window.languages.productFormUnavailable))),
                this.options.showPaymentButton &&
                  n &&
                  (t && t.available
                    ? (n.style.display = "block")
                    : (n.style.display = "none"));
            },
          },
          {
            key: "_onOptionChanged",
            value: function e(t, i, n) {
              // added by developer
            let is_color_swatch=false; 
              if (n)
                (this["option" + i.getAttribute("data-option-position")] = t),
                  (n.querySelector(".ProductForm__SelectedValue").innerHTML =
                    t);
              else {
                this["option" + i.getAttribute("data-option-position")] =
                  i.value;
                var s = i
                  .closest(".ProductForm__Option")
                  .querySelector(".ProductForm__SelectedValue");
                s && (s.innerHTML = i.value);
                // added by developer
                is_color_swatch=true;
              }
              var a = this.currentVariant;
              (this.currentVariant = this._getCurrentVariantFromOptions()),
                this._onVariantChanged(a, this.currentVariant),
                this.currentVariant &&
                  (this.options.enableHistoryState &&
                    this._updateHistoryState(this.currentVariant,is_color_swatch),
                  this.masterSelector
                    .querySelector("[selected]")
                    .removeAttribute("selected"),
                  this.masterSelector
                    .querySelector(
                      '[value="'.concat(this.currentVariant.id, '"]')
                    )
                    .setAttribute("selected", "selected"),
                  this.masterSelector.dispatchEvent(
                    new Event("change", { bubbles: !0 })
                  ));
            },
          },
          {
            key: "_getCurrentVariantFromOptions",
            value: function e() {
              var t = this,
                i = !1;
              return (
                this.productData.variants.forEach(function (e) {
                  e.option1 === t.option1 &&
                    e.option2 === t.option2 &&
                    e.option3 === t.option3 &&
                    (i = e);
                }),
                i || null
              );
            },
          },
          {
  key: "_updateHistoryState",
  value: function e(t, is_color_swatch) {
    if (!history.replaceState) return;

    // URL base com o variant correto
    var url = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + t.id;

    // Apenas atualiza o history state, sem redirecionar a página
    window.history.replaceState({ path: url }, "", url);
  },
},
          {
            key: "_addToCart",
            value: function e(t) {
              var i = this;
              if (this.options.useAjaxCart) {
                t.preventDefault();
                var n = this.element.querySelector(".ProductForm__AddToCart");
                n.setAttribute("disabled", "disabled"),
                  document.dispatchEvent(
                    new CustomEvent("theme:loading:start")
                  );
                var s = this.element.querySelector('form[action*="/cart/add"]');
                fetch("".concat(window.routes.cartAddUrl, ".js"), {
                  body: JSON.stringify(_.serialize(s)),
                  credentials: "same-origin",
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                }).then(function (e) {
                  document.dispatchEvent(new CustomEvent("theme:loading:end"));
                  var t = s.querySelector('[name="quantity"]');
                  e.ok
                    ? (n.removeAttribute("disabled"),
                      i.element.dispatchEvent(
                        new CustomEvent("product:added", {
                          bubbles: !0,
                          detail: {
                            variant: i.currentVariant,
                            quantity: t ? parseInt(t.value) : 1,
                          },
                        })
                      ))
                    : e.json().then(function (e) {
                        var t = document.createElement("span");
                        (t.className = "ProductForm__Error Alert Alert--error"),
                          (t.innerHTML = e.description),
                          n.removeAttribute("disabled"),
                          n.insertAdjacentElement("afterend", t),
                          setTimeout(function () {
                            t.remove();
                          }, 2500);
                      });
                }),
                  t.preventDefault();
              }
            },
          },
          {
            key: "_decreaseQuantity",
            value: function e(t, i) {
              i.nextElementSibling.value = Math.max(
                parseInt(i.nextElementSibling.value) - 1,
                1
              );
            },
          },
          {
            key: "_increaseQuantity",
            value: function e(t, i) {
              i.previousElementSibling.value =
                parseInt(i.previousElementSibling.value) + 1;
            },
          },
          {
            key: "_validateQuantity",
            value: function e(t, i) {
              i.value = Math.max(parseInt(i.value) || 1, 1);
            },
          },
        ]),
        t
      );
    })(),
    O = (function () {
      function t(i, n, s) {
        switch (
          (e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.stackProductImages = n),
          (this.enableVideoLooping = s),
          (this.player = null),
          this.element.getAttribute("data-media-type"))
        ) {
          case "video":
            var a = document.createElement("link");
            (a.rel = "stylesheet"),
              (a.href =
                "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"),
              document.head.appendChild(a),
              window.Shopify.loadFeatures([
                {
                  name: "video-ui",
                  version: "1.0",
                  onLoad: this._setupHtml5Video.bind(this),
                },
              ]);
            break;
          case "external_video":
            this._setupExternalVideo();
        }
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              this.player && this.player.destroy();
            },
          },
          {
            key: "hasBeenSelected",
            value: function e() {
              v.matchesBreakpoint("supports-hover") && this.play();
            },
          },
          {
            key: "hasBeenDeselected",
            value: function e() {
              this.pause();
            },
          },
          {
            key: "play",
            value: function e() {
              switch (this.element.getAttribute("data-media-type")) {
                case "video":
                  this.player.play();
                  break;
                case "external_video":
                  this.player.playVideo();
              }
            },
          },
          {
            key: "pause",
            value: function e() {
              switch (this.element.getAttribute("data-media-type")) {
                case "video":
                  this.player.pause();
                  break;
                case "external_video":
                  this.player.pauseVideo();
              }
            },
          },
          {
            key: "_setupHtml5Video",
            value: function e() {
              var t = this;
              (this.player = new Shopify.Plyr(
                this.element.querySelector("video"),
                {
                  controls: [
                    "play",
                    "progress",
                    "mute",
                    "volume",
                    "play-large",
                    "fullscreen",
                  ],
                  loop: { active: this.enableVideoLooping },
                  hideControlsOnPause: !0,
                  clickToPlay: !0,
                  iconUrl:
                    "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                  tooltips: { controls: !1, seek: !0 },
                }
              )),
                this.player.on("play", function () {
                  t.element.dispatchEvent(
                    new CustomEvent("video:played", { bubbles: !0 })
                  );
                }),
                this.player.on("pause", function () {
                  t.element.dispatchEvent(
                    new CustomEvent("video:paused", { bubbles: !0 })
                  );
                });
            },
          },
          {
            key: "_setupExternalVideo",
            value: function e() {
              "youtube" === this.element.getAttribute("data-video-host") &&
                this._loadYouTubeScript().then(
                  this._setupYouTubePlayer.bind(this)
                );
            },
          },
          {
            key: "_setupYouTubePlayer",
            value: function e() {
              var t = this,
                i = setInterval(function () {
                  void 0 !== window.YT &&
                    void 0 !== window.YT.Player &&
                    ((t.player = new YT.Player(
                      t.element.querySelector("iframe"),
                      {
                        videoId: t.element.getAttribute("data-video-id"),
                        events: {
                          onStateChange: function e(i) {
                            i.data === window.YT.PlayerState.PLAYING
                              ? t.element.dispatchEvent(
                                  new CustomEvent("video:played", {
                                    bubbles: !0,
                                  })
                                )
                              : i.data === YT.PlayerState.PAUSED &&
                                t.element.dispatchEvent(
                                  new CustomEvent("video:paused", {
                                    bubbles: !0,
                                  })
                                ),
                              i.data === window.YT.PlayerState.ENDED &&
                                t.enableVideoLooping &&
                                i.target.seekTo(0);
                          },
                        },
                      }
                    )),
                    clearInterval(i));
                }, 50);
            },
          },
          {
            key: "_loadYouTubeScript",
            value: function e() {
              return new Promise(function (e, t) {
                var i = document.createElement("script");
                document.body.appendChild(i),
                  (i.onload = e),
                  (i.onerror = t),
                  (i.async = !0),
                  (i.src = "//www.youtube.com/iframe_api");
              });
            },
          },
        ]),
        t
      );
    })(),
    B = (function () {
      function t(i, n, s) {
        var a = this;
        e(this, t),
          (this.container = i),
          (this.targets = []),
          (this.targetIndices = {}),
          (this.indicesInViewPort = []),
          (this.observer = new IntersectionObserver(
            this._onIntersectionChange.bind(this),
            s
          )),
          n.forEach(function (e, t) {
            a.targets.push(e),
              (a.targetIndices[e.id] = t),
              a.observer.observe(e);
          });
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              this.observer.disconnect();
            },
          },
          {
            key: "_onIntersectionChange",
            value: function e(t) {
              for (
                var i = this.indicesInViewPort[0] || 0, n = t.length - 1;
                n >= 0;
                n--
              )
                this._updateIndicesInViewPort(t[n], i);
              if (
                ((this.indicesInViewPort = this.indicesInViewPort.filter(
                  function (e, t, i) {
                    return i.indexOf(e) === t;
                  }
                )),
                0 !== this.indicesInViewPort.length &&
                  i !== this.indicesInViewPort[0])
              ) {
                var s = new CustomEvent("scrollspy:target:changed", {
                  detail: {
                    newTarget: this.targets[this.indicesInViewPort[0]],
                    oldTarget: this.targets[i],
                  },
                });
                this.container.dispatchEvent(s);
              }
            },
          },
          {
            key: "_updateIndicesInViewPort",
            value: function e(t, i) {
              var n = this.targetIndices[t.target.id];
              if (0 === t.intersectionRatio) {
                var s = this.indicesInViewPort.indexOf(n);
                -1 !== s && this.indicesInViewPort.splice(s, 1);
              } else
                n < i
                  ? this.indicesInViewPort.unshift(n)
                  : n >
                    this.indicesInViewPort[this.indicesInViewPort.length - 1]
                  ? this.indicesInViewPort.push(n)
                  : (this.indicesInViewPort.push(n),
                    this.indicesInViewPort.sort());
            },
          },
        ]),
        t
      );
    })(),
    D = (function () {
      function t() {
        e(this, t),
          (this.documentDelegate = new domDelegate.Delegate(document.body)),
          (this.searchElement = document.getElementById("Search")),
          (this.searchInputElement =
            this.searchElement.querySelector('[name="q"]')),
          (this.searchResultsElement =
            this.searchElement.querySelector(".Search__Results")),
          (this.queryMap = {}),
          (this.isOpen = !1),
          (this.pageOverlayElement = document.querySelector(".PageOverlay")),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              this.searchInputElement.removeEventListener(
                "keydown",
                this._preventSubmissionListener
              ),
                this.searchInputElement.removeEventListener(
                  "input",
                  this._onInputListener
                ),
                this.documentDelegate.off();
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._preventSubmissionListener =
                this._preventSubmission.bind(this)),
                (this._onInputListener = this._debounce(
                  this._onInput.bind(this),
                  250
                )),
                this.searchInputElement.addEventListener(
                  "keydown",
                  this._preventSubmissionListener
                ),
                this.searchInputElement.addEventListener(
                  "input",
                  this._onInputListener
                ),
                this.documentDelegate.on(
                  "click",
                  '[data-action="toggle-search"]',
                  this._toggleSearch.bind(this)
                ),
                this.documentDelegate.on(
                  "click",
                  '[data-action="open-search"]',
                  this._openSearch.bind(this)
                ),
                this.documentDelegate.on(
                  "click",
                  '[data-action="close-search"]',
                  this._closeSearch.bind(this)
                ),
                this.documentDelegate.on(
                  "search:close",
                  this._closeSearch.bind(this)
                );
            },
          },
          {
            key: "_toggleSearch",
            value: function e(t) {
              this.isOpen ? this._closeSearch(t) : this._openSearch(t),
                t.preventDefault();
            },
          },
          {
            key: "_openSearch",
            value: function e() {
              var t = this;
              this.searchElement.setAttribute("aria-hidden", "false"),
                document.documentElement.classList.add("no-scroll"),
                k.trapFocus(
                  this.searchElement,
                  "search",
                  this.searchElement.querySelector('[name="q"]')
                );
              var i = function e() {
                t.searchInputElement.focus(),
                  t.searchElement.removeEventListener("transitionend", e);
              };
              this.searchElement.addEventListener("transitionend", i),
                (this.isOpen = !0),
                this.pageOverlayElement.classList.add("is-visible"),
                (document.querySelector(
                  "#shopify-section-header"
                ).style.zIndex = 10);
            },
          },
          {
            key: "_closeSearch",
            value: function e() {
              var t = this;
              this.searchElement.setAttribute("aria-hidden", "true"),
                document.documentElement.classList.remove("no-scroll"),
                k.removeTrapFocus(this.searchElement, "search"),
                (this.isOpen = !1);
              var i = function e(i) {
                "visibility" === i.propertyName &&
                  ((document.querySelector(
                    "#shopify-section-header"
                  ).style.zIndex = ""),
                  t.pageOverlayElement.removeEventListener("transitionend", e));
              };
              this.pageOverlayElement.addEventListener("transitionend", i),
                this.pageOverlayElement.classList.remove("is-visible");
            },
          },
          {
            key: "_preventSubmission",
            value: function e(t) {
              13 === t.keyCode &&
                "product" !== window.theme.searchMode &&
                t.preventDefault();
            },
          },
          {
            key: "_onInput",
            value: function e(t) {
              var i = this;
              if (13 !== t.keyCode) {
                if (
                  ((this.lastInputValue = t.target.value),
                  "" === this.lastInputValue)
                ) {
                  this._resetSearch();
                  return;
                }
                var n = { method: "GET", credentials: "same-origin" },
                  s = [
                    fetch(
                      ""
                        .concat(
                          window.routes.searchUrl,
                          "?section_id=predictive-search&q="
                        )
                        .concat(
                          encodeURIComponent(this.lastInputValue),
                          "&options[prefix]=last&type=product"
                        ),
                      n
                    ),
                  ];
                "product" !== window.theme.searchMode &&
                  s.push(
                    fetch(
                      ""
                        .concat(
                          window.routes.searchUrl,
                          "?section_id=predictive-search&q="
                        )
                        .concat(
                          encodeURIComponent(this.lastInputValue),
                          "&options[prefix]=last&type="
                        )
                        .concat(
                          window.theme.searchMode.replace("product,", "")
                        ),
                      n
                    )
                  ),
                  (this.queryMap[this.lastInputValue] = !0),
                  document.dispatchEvent(
                    new CustomEvent("theme:loading:start")
                  ),
                  Promise.all(s).then(function (e) {
                    i.lastInputValue === t.target.value &&
                      (delete i.queryMap[t.target.value],
                      Promise.all(
                        e.map(function (e) {
                          return e.text();
                        })
                      ).then(function (e) {
                        "product" === window.theme.searchMode
                          ? (i.searchResultsElement.innerHTML = e[0])
                          : (i.searchResultsElement.innerHTML =
                              '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section">'
                                .concat(
                                  e[0],
                                  '</div>\n              <div class="PageLayout__Section PageLayout__Section--secondary">'
                                )
                                .concat(e[1], "</div>\n            </div>")),
                          i.searchResultsElement.setAttribute(
                            "aria-hidden",
                            "false"
                          );
                      }),
                      document.dispatchEvent(
                        new CustomEvent("theme:loading:end")
                      ));
                  });
              }
            },
          },
          {
            key: "_resetSearch",
            value: function e() {
              "product" === window.theme.searchMode
                ? (this.searchResultsElement.innerHTML = "")
                : (this.searchResultsElement.innerHTML =
                    '<div class="PageLayout PageLayout--breakLap">\n              <div class="PageLayout__Section"></div>\n              <div class="PageLayout__Section PageLayout__Section--secondary"></div>\n            </div>'),
                this.searchResultsElement.setAttribute("aria-hidden", "true"),
                document.dispatchEvent(new CustomEvent("theme:loading:end"));
            },
          },
          {
            key: "_debounce",
            value: function e(t, i) {
              var n = this,
                s = null;
              return function () {
                for (var e = arguments.length, a = Array(e), o = 0; o < e; o++)
                  a[o] = arguments[o];
                clearTimeout(s),
                  (s = setTimeout(function () {
                    t.apply(n, a);
                  }, i));
              };
            },
          },
        ]),
        t
      );
    })(),
    N = (function () {
      function t(i, n) {
        e(this, t),
          (this.countrySelect = i),
          (this.provinceSelect = n),
          this.countrySelect &&
            this.provinceSelect &&
            (this._attachListeners(), this._initSelectors());
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              this.countrySelect &&
                this.countrySelect.removeEventListener(
                  "change",
                  this._onCountryChangedListener
                );
            },
          },
          {
            key: "_initSelectors",
            value: function e() {
              var t = this.countrySelect.getAttribute("data-default");
              if (t) {
                for (var i = 0; i !== this.countrySelect.options.length; ++i)
                  if (this.countrySelect.options[i].text === t) {
                    this.countrySelect.selectedIndex = i;
                    break;
                  }
              } else this.countrySelect.selectedIndex = 0;
              var n = new Event("change", { bubbles: !0 });
              this.countrySelect.dispatchEvent(n);
              var s = this.provinceSelect.getAttribute("data-default");
              if (s) {
                for (var a = 0; a !== this.provinceSelect.options.length; ++a)
                  if (this.provinceSelect.options[a].text === s) {
                    this.provinceSelect.selectedIndex = a;
                    break;
                  }
              }
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._onCountryChangedListener =
                this._onCountryChanged.bind(this)),
                this.countrySelect.addEventListener(
                  "change",
                  this._onCountryChangedListener
                );
            },
          },
          {
            key: "_onCountryChanged",
            value: function e() {
              var t = this,
                i = JSON.parse(
                  this.countrySelect.options[
                    this.countrySelect.selectedIndex
                  ].getAttribute("data-provinces") || "[]"
                );
              if (((this.provinceSelect.innerHTML = ""), 0 === i.length)) {
                this.provinceSelect.parentNode.style.display = "none";
                return;
              }
              i.forEach(function (e) {
                t.provinceSelect.options.add(new Option(e[1], e[0]));
              }),
                (this.provinceSelect.parentNode.style.display = "block");
            },
          },
        ]),
        t
      );
    })(),
    V = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.countrySelector = new N(
            this.element.querySelector('[name="country"]'),
            this.element.querySelector('[name="province"]')
          )),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.delegateElement.off("click"), this.countrySelector.destroy();
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              this.delegateElement.on(
                "click",
                ".ShippingEstimator__Submit",
                this._fetchRates.bind(this)
              );
            },
          },
          {
            key: "_fetchRates",
            value: function e() {
              var t = this,
                i = this.element.querySelector('[name="country"]').value,
                n = this.element.querySelector('[name="province"]').value,
                s = this.element.querySelector('[name="zip"]').value;
              document.dispatchEvent(new CustomEvent("theme:loading:start")),
                fetch(
                  ""
                    .concat(
                      window.routes.cartUrl,
                      "/shipping_rates.json?shipping_address[zip]="
                    )
                    .concat(s, "&shipping_address[country]=")
                    .concat(i, "&shipping_address[province]=")
                    .concat(n),
                  { credentials: "same-origin", method: "GET" }
                ).then(function (e) {
                  e.json().then(function (i) {
                    document.dispatchEvent(
                      new CustomEvent("theme:loading:end")
                    );
                    var n = t.element.querySelector(
                        ".ShippingEstimator__Results"
                      ),
                      s = t.element.querySelector(".ShippingEstimator__Error");
                    if (e.ok) {
                      var a = i.shipping_rates;
                      if (0 === a.length)
                        n.innerHTML = "<p>".concat(
                          window.languages.shippingEstimatorNoResults,
                          "</p>"
                        );
                      else {
                        var o = "";
                        1 === a.length
                          ? (o += "<p>".concat(
                              window.languages.shippingEstimatorOneResult,
                              "</p><ul>"
                            ))
                          : (o += "<p>".concat(
                              window.languages.shippingEstimatorMoreResults.replace(
                                "{{count}}",
                                a.length
                              ),
                              "</p><ul>"
                            )),
                          a.forEach(function (e) {
                            o += "<li>"
                              .concat(e.name, ": ")
                              .concat(
                                x.formatMoney(
                                  e.price,
                                  window.theme.moneyFormat
                                ),
                                "</li>"
                              );
                          }),
                          (o += "</ul>"),
                          (n.firstElementChild.innerHTML = o);
                      }
                      TweenLite.fromTo(
                        n.firstElementChild,
                        0.6,
                        { autoAlpha: 0, y: -15 },
                        { autoAlpha: 1, y: 0, delay: 0.35 }
                      ),
                        (s.style.display = "none"),
                        (n.style.display = "block"),
                        y.slideDown(n);
                    } else {
                      var r = "";
                      Object.keys(i).forEach(function (e) {
                        r += '<li class="Alert__ErrorItem">'
                          .concat(e, " ")
                          .concat(i[e], "</li>");
                      }),
                        (s.innerHTML = '<ul class="Alert__ErrorList">'.concat(
                          r,
                          "</ul>"
                        )),
                        (n.style.display = "none"),
                        (s.style.display = "block");
                    }
                  });
                });
            },
          },
        ]),
        t
      );
    })(),
    F = function t() {
      var i = this;
      e(this, t),
        (this.countrySelectors = []),
        g
          .nodeListToArray(document.querySelectorAll(".Modal--address"))
          .forEach(function (e) {
            i.countrySelectors.push(
              new N(
                e.querySelector('[name="address[country]"]'),
                e.querySelector('[name="address[province]"]')
              )
            );
          });
    },
    R = (function () {
      function t(i) {
        var n = this;
        e(this, t),
          (this.element = i),
          window.theme.showElementStaggering &&
            ((this.timeline = new TimelineLite({
              delay: window.theme.showPageTransition ? 0.5 : 0,
            })),
            (this.intersectionObserver = new IntersectionObserver(
              this._reveal.bind(this)
            )),
            g
              .nodeListToArray(this.element.querySelectorAll(".ArticleItem"))
              .forEach(function (e) {
                n.intersectionObserver.observe(e);
              }));
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              window.theme.showElementStaggering &&
                (this.intersectionObserver.disconnect(), this.timeline.kill());
            },
          },
          {
            key: "_reveal",
            value: function e(t) {
              var i = this,
                n = [];
              t.forEach(function (e) {
                (e.isIntersecting || e.intersectionRatio > 0) &&
                  (n.push(e.target),
                  i.intersectionObserver.unobserve(e.target));
              }),
                0 !== n.length &&
                  this.timeline.staggerFromTo(
                    n,
                    0.45,
                    { autoAlpha: 0, y: 30 },
                    { autoAlpha: 1, y: 0 },
                    0.2
                  );
            },
          },
        ]),
        t
      );
    })(),
    z = (function () {
      function t(i) {
        var n = this;
        e(this, t),
          (this.element = i),
          (this.toolbarElement = this.element.querySelector(".ArticleToolbar")),
          (this.articleNavElement = this.element.querySelector(".ArticleNav")),
          this.element.querySelector(".Article__Image") &&
            window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)")
              .matches &&
            (this.parallaxInstance = new Rellax(".Article__Image", {
              speed: -7,
              center: !1,
              round: !0,
            })),
          window.theme.showElementStaggering &&
            ((this.timeline = new TimelineLite({
              delay: window.theme.showPageTransition ? 0.5 : 0,
            })),
            (this.intersectionObserver = new IntersectionObserver(
              this._reveal.bind(this)
            )),
            g
              .nodeListToArray(this.element.querySelectorAll(".ArticleItem"))
              .forEach(function (e) {
                n.intersectionObserver.observe(e);
              })),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.parallaxInstance && this.parallaxInstance.destroy(),
                window.theme.showElementStaggering &&
                  (this.intersectionObserver.disconnect(),
                  this.timeline.kill()),
                window.removeEventListener("scroll", this._onScrollListener);
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._onScrollListener =
                this._checkToolbarVisibility.bind(this)),
                window.addEventListener("scroll", this._onScrollListener);
            },
          },
          {
            key: "_checkToolbarVisibility",
            value: function e() {
              var t = this,
                i = 0,
                n = 0,
                s = 0,
                a = 0,
                o = document.querySelector(".Header");
              fastdom.measure(function () {
                (i = window.pageYOffset),
                  (n = o.offsetHeight),
                  (a = parseInt(
                    window
                      .getComputedStyle(document.body)
                      .getPropertyValue("--use-sticky-header") || 0
                  )),
                  t.articleNavElement &&
                    (s =
                      t.articleNavElement.offsetTop +
                      t.articleNavElement.clientHeight -
                      n);
              }),
                fastdom.mutate(function () {
                  (t.toolbarElement.style.top = a ? n + "px" : null),
                    t.articleNavElement
                      ? i > 150 && t.articleNavElement && i < s
                        ? t.toolbarElement.classList.add("is-visible")
                        : t.toolbarElement.classList.remove("is-visible")
                      : i > 150
                      ? t.toolbarElement.classList.add("is-visible")
                      : t.toolbarElement.classList.remove("is-visible");
                });
            },
          },
          {
            key: "_reveal",
            value: function e(t) {
              var i = this,
                n = [];
              t.forEach(function (e) {
                (e.isIntersecting || e.intersectionRatio > 0) &&
                  (n.push(e.target),
                  i.intersectionObserver.unobserve(e.target));
              }),
                0 !== n.length &&
                  this.timeline.staggerFromTo(
                    n,
                    0.45,
                    { autoAlpha: 0, y: 30 },
                    { autoAlpha: 1, y: 0 },
                    0.2
                  );
            },
          },
        ]),
        t
      );
    })(),
    U = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.documentDelegate = new domDelegate.Delegate(
            document.documentElement
          )),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          (this.itemCount = this.options.itemCount),
          (this.isCartNoteOpen = !1),
          this.options.drawer &&
            (this.sidebarDrawer = new S(this.element, {
              onClose: this._onDrawerClosed.bind(this),
            })),
          this.options.hasShippingEstimator &&
            (this.shippingEstimator = new V(
              this.element.querySelector(".ShippingEstimator")
            )),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.options.hasShippingEstimator &&
                this.shippingEstimator.destroy(),
                this.delegateElement.off(),
                document.removeEventListener(
                  "product:added",
                  this._onProductAddedListener
                );
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._onProductAddedListener = this._onProductAdded.bind(this)),
                this.delegateElement.on(
                  "change",
                  "#cart-note",
                  this._updateCartNote.bind(this)
                ),
                "page" !== this.options.type
                  ? (this.delegateElement.on(
                      "click",
                      '[data-action="update-item-quantity"], [data-action="remove-item"]',
                      this._updateItemQuantity.bind(this)
                    ),
                    this.delegateElement.on(
                      "change",
                      ".QuantitySelector__CurrentQuantity",
                      this._updateItemQuantity.bind(this)
                    ))
                  : this.delegateElement.on(
                      "change",
                      ".QuantitySelector__CurrentQuantity",
                      this._reloadPageWithQuantity.bind(this)
                    ),
                this.options.drawer &&
                  this.delegateElement.on(
                    "click",
                    '[data-action="toggle-cart-note"]',
                    this._toggleCartNote.bind(this)
                  ),
                document.addEventListener(
                  "product:added",
                  this._onProductAddedListener
                ),
                this.documentDelegate.on(
                  "cart:refresh",
                  this._rerenderCart.bind(this, !1)
                );
            },
          },
          {
            key: "_updateCartNote",
            value: function e(t, i) {
              fetch("".concat(window.routes.cartUrl, "/update.js"), {
                body: JSON.stringify({ note: i.value }),
                credentials: "same-origin",
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                },
              });
            },
          },
          {
            key: "_toggleCartNote",
            value: function e() {
              var t = this,
                i = this.element.querySelector(".Cart__OffscreenNoteContainer"),
                n = this.element.querySelector("#cart-note");
              if (
                (this.element.classList.toggle("has-note-open"),
                (this.element.querySelector(".Cart__NoteButton").innerHTML =
                  "" !== n.value
                    ? window.languages.cartEditNote
                    : window.languages.cartAddNote),
                i.setAttribute(
                  "aria-hidden",
                  "true" === i.getAttribute("aria-hidden") ? "false" : "true"
                ),
                (this.isCartNoteOpen =
                  "false" === i.getAttribute("aria-hidden")),
                this.element.classList.contains("has-note-open"))
              ) {
                var s = function e() {
                  t.element.querySelector("#cart-note").focus(),
                    i.removeEventListener("transitionend", e);
                };
                i.addEventListener("transitionend", s);
              }
            },
          },
          {
            key: "_updateItemQuantity",
            value: function e(t, i) {
              var n = this;
              document.dispatchEvent(new CustomEvent("theme:loading:start"));
              var s = null,
                a = null;
              0 ===
                (s =
                  "INPUT" === i.tagName
                    ? parseInt(Math.max(parseInt(i.value) || 1, 1))
                    : parseInt(i.getAttribute("data-quantity"))) &&
                (a = i.closest(".CartItemWrapper")),
                fetch("".concat(window.routes.cartChangeUrl, ".js"), {
                  body: JSON.stringify({
                    line: i.getAttribute("data-line"),
                    quantity: s,
                  }),
                  credentials: "same-origin",
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                }).then(function (e) {
                  e.json().then(function (e) {
                    (n.itemCount = e.item_count),
                      n._rerenderCart(a),
                      document.dispatchEvent(
                        new CustomEvent("theme:loading:end")
                      );
                  });
                }),
                t.preventDefault();
            },
          },
          {
            key: "_reloadPageWithQuantity",
            value: function e(t, i) {
              window.location.href = ""
                .concat(window.routes.cartChangeUrl, "?quantity=")
                .concat(parseInt(i.value), "&line=")
                .concat(i.getAttribute("data-line"));
            },
          },
          {
            key: "_onProductAdded",
            value: function e(t) {
              var i = this;
              (this.itemCount += t.detail.quantity),
                this._rerenderCart().then(function () {
                  i.sidebarDrawer.open();
                });
            },
          },
          {
            key: "_onDrawerClosed",
            value: function e() {
              this.isCartNoteOpen && this._toggleCartNote();
            },
          },
          {
            key: "_rerenderCart",
            value: function e(t) {
              var i = this;
              return fetch(
                ""
                  .concat(window.routes.cartUrl, "?section_id=")
                  .concat(
                    this.options.drawer && "cart" !== window.theme.pageType
                      ? "mini-cart"
                      : "main-cart",
                    "&timestamp="
                  )
                  .concat(Date.now()),
                { credentials: "same-origin", method: "GET" }
              ).then(function (e) {
                if (i.options.drawer && t) {
                  var n = new TimelineLite({
                    onComplete: function t() {
                      e.text().then(function (e) {
                        i._replaceContent(e);
                      });
                    },
                  });
                  n.to(
                    t,
                    0.5,
                    { height: 0, opacity: 0, ease: Cubic.easeOut },
                    0
                  ),
                    0 === i.itemCount &&
                      n.to(
                        i.element.querySelector(".Drawer__Footer"),
                        0.5,
                        {
                          y: "100%",
                          transition: "none",
                          ease: Cubic.easeInOut,
                        },
                        0
                      );
                } else
                  e.text().then(function (e) {
                    i._replaceContent(e);
                  });
              });
            },
          },
          {
            key: "_replaceContent",
            value: function e(t) {
              var i = this,
                n = document.createElement("div");
              n.innerHTML = t;
              var s = this.element.querySelector(".Cart").parentNode;
              if (this.options.drawer && "cart" !== window.theme.pageType) {
                var a = this.element.querySelector(".Drawer__Main").scrollTop;
                s.replaceChild(
                  n.querySelector(".Cart"),
                  this.element.querySelector(".Cart")
                ),
                  (this.element.querySelector(".Drawer__Main").scrollTop = a);
              } else
                0 === this.itemCount
                  ? (this.element.innerHTML =
                      n.querySelector(
                        ".shopify-section"
                      ).firstElementChild.innerHTML)
                  : (s.replaceChild(
                      n.querySelector(".Cart"),
                      this.element.querySelector(".Cart")
                    ),
                    (this.element.querySelector(".PageHeader").innerHTML =
                      n.querySelector(".PageHeader").innerHTML));
              var o = JSON.parse(
                  n
                    .querySelector('[data-section-type="cart"]')
                    .getAttribute("data-section-settings")
                ),
                r = g.nodeListToArray(
                  document.querySelectorAll(".Header__CartDot")
                ),
                l = g.nodeListToArray(
                  document.querySelectorAll(".Header__CartCount")
                );
              (this.itemCount = o.itemCount),
                r.forEach(function (e) {
                  0 === i.itemCount
                    ? e.classList.remove("is-visible")
                    : e.classList.add("is-visible");
                }),
                l.forEach(function (e) {
                  e.textContent = i.itemCount;
                });
            },
          },
        ]),
        t
      );
    })(),
    W = (function () {
      function t(i) {
        e(this, t), (this.element = i);
        var n = this.element.querySelector("[data-flickity-config]");
        n && (this.carousel = new f(n));
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.carousel && this.carousel.destroy();
            },
          },
          {
            key: "onBlockSelect",
            value: function e(t) {
              this.carousel &&
                this.carousel.selectCell(
                  t.target.getAttribute("data-slide-index"),
                  !0,
                  !t.detail.load
                );
            },
          },
          {
            key: "onBlockDeselect",
            value: function e() {
              this.carousel && this.carousel.unpausePlayer();
            },
          },
        ]),
        t
      );
    })(),
    Y = (function () {
      function t(i) {
        e(this, t),
          i &&
            ((this.element = i),
            (this.lastKnownY = window.scrollY),
            (this.currentTop = 0),
            (this.initialTopOffset = parseInt(
              window.getComputedStyle(this.element).top
            )),
            this._attachListeners());
      }
      return (
        i(t, [
          {
            key: "destroy",
            value: function e() {
              window.removeEventListener("scroll", this._checkPositionListener);
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._checkPositionListener = this._checkPosition.bind(this)),
                window.addEventListener("scroll", this._checkPositionListener);
            },
          },
          {
            key: "_checkPosition",
            value: function e() {
              var t = this;
              fastdom.measure(function () {
                var e =
                    t.element.getBoundingClientRect().top +
                    window.scrollY -
                    t.element.offsetTop +
                    t.initialTopOffset,
                  i = t.element.clientHeight - window.innerHeight;
                window.scrollY < t.lastKnownY
                  ? (t.currentTop -= window.scrollY - t.lastKnownY)
                  : (t.currentTop += t.lastKnownY - window.scrollY),
                  (t.currentTop = Math.min(
                    Math.max(t.currentTop, -i),
                    e,
                    t.initialTopOffset
                  )),
                  (t.lastKnownY = window.scrollY);
              }),
                fastdom.mutate(function () {
                  t.element.style.top = "".concat(t.currentTop, "px");
                });
            },
          },
        ]),
        t
      );
    })(),
    Q = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.toolbarElement =
            this.element.querySelector(".CollectionToolbar")),
          (this.collectionInnerElement = this.element.querySelector(
            ".CollectionInner__Products"
          )),
          (this.settings = JSON.parse(
            this.element.getAttribute("data-section-settings")
          ));
        var n = document.getElementById("collection-sort-popover");
        n &&
          (this.sortPopover = new E(n, {
            onValueChanged: this._sortByChanged.bind(this),
          }));
        var s = document.getElementById("collection-filter-drawer");
        s && (this.filterDrawer = new S(s)),
          "sidebar" === this.settings.filterPosition &&
            (this.filterInnerSidebarScroller = new Y(
              this.element.querySelector(".CollectionInner__Sidebar")
            )),
          this.element.querySelector(".PageHeader__ImageWrapper") &&
            window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)")
              .matches &&
            (this.parallaxInstance = new Rellax(".PageHeader__ImageWrapper", {
              speed: -7,
              center: !1,
              round: !0,
            })),
          new A(this.element.querySelector(".ProductList")),
          (this.timeline = new TimelineLite({
            delay: window.theme.showPageTransition ? 0.5 : 0,
          })),
          this._setupAnimation(),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.delegateElement.off("click"),
                this.sortPopover && this.sortPopover.destroy(),
                this.filterDrawer && this.filterDrawer.destroy(),
                this.filterInnerSidebarScroller &&
                  this.filterInnerSidebarScroller.destroy(),
                this.parallaxInstance && this.parallaxInstance.destroy(),
                window.theme.showElementStaggering &&
                  (this.intersectionObserver.disconnect(),
                  this.timeline.kill());
            },
          },
          {
            key: "_setupAnimation",
            value: function e() {
              var t = this,
                i =
                  arguments.length > 0 &&
                  void 0 !== arguments[0] &&
                  arguments[0];
              window.theme.showElementStaggering &&
                (this.intersectionObserver &&
                  this.intersectionObserver.disconnect(),
                i
                  ? (this.timeline.clear(),
                    this.timeline.staggerFromTo(
                      this.element.querySelectorAll(
                        ".ProductList .ProductItem, .ArticleList .ArticleItem"
                      ),
                      0.25,
                      { autoAlpha: 0, y: 25 },
                      { autoAlpha: 1, y: 0 },
                      0.1
                    ))
                  : ((this.intersectionObserver = new IntersectionObserver(
                      this._reveal.bind(this),
                      { threshold: 0.3 }
                    )),
                    g
                      .nodeListToArray(
                        this.element.querySelectorAll(
                          ".ProductList .ProductItem, .ArticleList .ArticleItem"
                        )
                      )
                      .forEach(function (e) {
                        t.intersectionObserver.observe(e);
                      })));
            },
          },
          {
            key: "_reveal",
            value: function e(t) {
              var i = this,
                n = [];
              t.forEach(function (e) {
                (e.isIntersecting || e.intersectionRatio > 0) &&
                  (n.push(e.target),
                  i.intersectionObserver.unobserve(e.target));
              }),
                0 !== n.length &&
                  this.timeline.staggerFromTo(
                    n,
                    0.35,
                    { autoAlpha: 0, y: 25 },
                    { autoAlpha: 1, y: 0 },
                    0.15
                  );
            },
          },
          {
            key: "_changeLayoutMode",
            value: function e(t, i) {
              var n,
                s,
                a,
                o = this,
                r = i.getAttribute("data-grid-type"),
                l = parseInt(i.getAttribute("data-count")),
                c = this.collectionInnerElement.querySelector(".ProductList");
              if (c) {
                var h = parseInt(c.getAttribute("data-".concat(r, "-count")));
                if (h === l) return;
                c.setAttribute("data-".concat(r, "-count"), l),
                  g
                    .nodeListToArray(c.querySelectorAll(".Grid__Cell"))
                    .forEach(function (e) {
                      "mobile" === r
                        ? (e.classList.remove("1/".concat(h, "--phone")),
                          e.classList.add("1/".concat(l, "--phone")))
                        : ("drawer" === o.settings.filterPosition
                            ? (e.classList.remove(
                                "1/".concat(h, "--lap-and-up")
                              ),
                              e.classList.add("1/".concat(l, "--lap-and-up")))
                            : (e.classList.remove("1/".concat(h, "--desk")),
                              e.classList.add("1/".concat(l, "--desk"))),
                          e.classList.remove(
                            "1/".concat(2 === h ? 2 : 3, "--tablet-and-up")
                          ),
                          e.classList.add(
                            "1/".concat(2 === l ? 2 : 3, "--tablet-and-up")
                          )),
                        window.theme.showElementStaggering &&
                          (e.firstElementChild.style.visibility = "hidden");
                    }),
                  lazySizes.autoSizer.checkElems();
              }
              i.classList.add("is-active"),
                g.getSiblings(i)[0].classList.remove("is-active"),
                this._setupAnimation(),
                fetch("".concat(window.routes.cartUrl, "/update.js"), {
                  body: JSON.stringify({
                    attributes:
                      ((n = {}),
                      (s = "collection_".concat(r, "_items_per_row")),
                      (a = l),
                      s in n
                        ? Object.defineProperty(n, s, {
                            value: a,
                            enumerable: !0,
                            configurable: !0,
                            writable: !0,
                          })
                        : (n[s] = a),
                      n),
                  }),
                  credentials: "same-origin",
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                  },
                });
            },
          },
          {
            key: "_sortByChanged",
            value: function e(t) {
              var i = new URL(location.href);
              i.searchParams.set("sort_by", t),
                i.searchParams.delete("page"),
                this._reloadProducts(i.toString());
            },
          },
          {
            key: "_onFiltersCleared",
            value: function e(t) {
              this._reloadProducts(t.target.getAttribute("data-url"));
            },
          },
          {
            key: "_onFilterChanged",
            value: function e(t) {
              var i = new FormData(t.target.closest("form")),
                n = new URLSearchParams(i).toString();
              this._reloadProducts(
                "".concat(window.location.pathname, "?").concat(n)
              );
            },
          },
          {
            key: "_reloadProducts",
            value: function e(t) {
              var i = this;
              this.abortController && this.abortController.abort(),
                document.dispatchEvent(new CustomEvent("theme:loading:start")),
                history.replaceState &&
                  window.history.pushState({ path: t }, "", t);
              var n = new URL(window.location);
              n.searchParams.set("section_id", this.settings.sectionId);
              try {
                (this.abortController = new AbortController()),
                  fetch(n.toString(), {
                    signal: this.abortController.signal,
                  }).then(function (e) {
                    e.text().then(function (e) {
                      var t = document.createElement("div");
                      (t.innerHTML = e),
                        (i.collectionInnerElement.innerHTML = t.querySelector(
                          ".CollectionInner__Products"
                        ).innerHTML);
                      var n = t.querySelector(
                        ".CollectionToolbar__Item--filter"
                      );
                      if (n) {
                        var s = i.element.querySelector(
                          ".CollectionToolbar__Item--filter"
                        );
                        (s.innerHTML = n.innerHTML),
                          (s.className = n.className);
                      }
                      var a = i.element.querySelector(
                          "#collection-filters-drawer-form"
                        ),
                        o = i.element.querySelector(
                          "#collection-filters-sidebar-form"
                        );
                      if (a) {
                        var r = t.querySelector(
                          "#collection-filters-drawer-form"
                        );
                        Array.from(a.querySelectorAll(".Collapsible")).forEach(
                          function (e) {
                            var t = r.querySelector(
                              '[data-filter-index="'.concat(
                                e.getAttribute("data-filter-index"),
                                '"]'
                              )
                            );
                            "true" ===
                              e.firstElementChild.getAttribute(
                                "aria-expanded"
                              ) &&
                              ((t.style.overflow = "visible"),
                              t.firstElementChild.setAttribute(
                                "aria-expanded",
                                "true"
                              ),
                              (t.lastElementChild.style.height = "auto"),
                              (t.lastElementChild.style.overflow = "visible"));
                          }
                        ),
                          (a.innerHTML = r.innerHTML),
                          new A(i.element.querySelector(".ProductList"));
                      }
                      if (o) {
                        var l = t.querySelector(
                          "#collection-filters-sidebar-form"
                        );
                        Array.from(o.querySelectorAll(".Collapsible")).forEach(
                          function (e) {
                            var t = l.querySelector(
                              '[data-filter-index="'.concat(
                                e.getAttribute("data-filter-index"),
                                '"]'
                              )
                            );
                            "true" ===
                              e.firstElementChild.getAttribute(
                                "aria-expanded"
                              ) &&
                              ((t.style.overflow = "visible"),
                              t.firstElementChild.setAttribute(
                                "aria-expanded",
                                "true"
                              ),
                              (t.lastElementChild.style.height = "auto"),
                              (t.lastElementChild.style.overflow = "visible"));
                          }
                        ),
                          (o.innerHTML = l.innerHTML);
                      }
                      document.dispatchEvent(
                        new CustomEvent("theme:loading:end")
                      ),
                        i._setupAnimation(!0);
                      var c =
                        i.element
                          .querySelector(".CollectionMain")
                          .getBoundingClientRect().top -
                        parseInt(
                          document.documentElement.style.getPropertyValue(
                            "--header-height"
                          )
                        );
                      v.matchesBreakpoint("lap-and-up") &&
                        i.toolbarElement &&
                        0 === i.toolbarElement.clientHeight &&
                        (c -= 50),
                        c < 0 &&
                          window.scrollBy({ top: c, behavior: "smooth" });
                    });
                  });
              } catch (s) {}
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._changeLayoutModeListener =
                this._changeLayoutMode.bind(this)),
                this.delegateElement.on(
                  "click",
                  '[data-action="change-layout-mode"]',
                  this._changeLayoutModeListener
                ),
                this.delegateElement.on(
                  "click",
                  '[data-action="clear-filters"]',
                  this._onFiltersCleared.bind(this)
                ),
                this.delegateElement.on(
                  "change",
                  '[name^="filter."]',
                  this._onFilterChanged.bind(this)
                ),
                window.addEventListener("popstate", function (e) {
                  e.state.path && (window.location.href = e.state.path);
                });
            },
          },
        ]),
        t
      );
    })(),
    j = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.delegateElement.off();
            },
          },
          {
            key: "onBlockSelect",
            value: function e(t) {
              this._openItem(t.target);
            },
          },
          {
            key: "onBlockDeselect",
            value: function e(t) {
              this._closeItem(t.target);
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              this.delegateElement.on(
                "click",
                ".Faq__Question",
                this._toggleItem.bind(this)
              ),
                this.delegateElement.on(
                  "click",
                  ".FaqSummary__Item",
                  this._switchToCategory.bind(this)
                );
            },
          },
          {
            key: "_switchToCategory",
            value: function e(t, i) {
              i.classList.add("is-active"),
                g.getSiblings(i, ".is-active").forEach(function (e) {
                  e.classList.remove("is-active");
                });
            },
          },
          {
            key: "_toggleItem",
            value: function e(t, i) {
              var n = i.closest(".Faq__Item");
              "true" === n.getAttribute("aria-expanded")
                ? this._closeItem(n)
                : this._openItem(n);
            },
          },
          {
            key: "_openItem",
            value: function e(t) {
              var i = t.querySelector(".Faq__AnswerWrapper");
              t.setAttribute("aria-expanded", "true"),
                i.setAttribute("aria-hidden", "false"),
                y.slideDown(i, !0),
                g
                  .getSiblings(t, '[aria-expanded="true"]')
                  .forEach(function (e) {
                    var t = e.querySelector(".Faq__AnswerWrapper");
                    e.setAttribute("aria-expanded", "false"),
                      t.setAttribute("aria-hidden", "true"),
                      y.slideUp(t);
                  });
            },
          },
          {
            key: "_closeItem",
            value: function e(t) {
              var i = t.querySelector(".Faq__AnswerWrapper");
              t.setAttribute("aria-expanded", "false"),
                i.setAttribute("aria-hidden", "true"),
                y.slideUp(i);
            },
          },
        ]),
        t
      );
    })(),
    K = (function () {
      function t(i) {
        var n = this;
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = JSON.parse(
            this.element.getAttribute("data-settings")
          )),
          (this.carousels = []),
          g
            .nodeListToArray(
              this.element.querySelectorAll("[data-flickity-config]")
            )
            .forEach(function (e) {
              n.carousels.push(new f(e));
            }),
          new A(this.element),
          this._setupAnimation(),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.carousels.forEach(function (e) {
                return e.destroy();
              }),
                this.delegateElement.off("click"),
                this.intersectionObserver.disconnect(),
                this.timeline.kill();
            },
          },
          {
            key: "onBlockSelect",
            value: function e(t) {
              this.element
                .querySelector('[aria-controls="'.concat(t.target.id, '"]'))
                .click();
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              this.delegateElement.on(
                "click",
                '[data-action="toggle-tab"]',
                this._switchTab.bind(this)
              );
            },
          },
          {
            key: "_switchTab",
            value: function e(t, i) {
              var n = this;
              if (!i.classList.contains("is-active")) {
                i.classList.add("is-active"),
                  g.getSiblings(i, ".is-active").forEach(function (e) {
                    e.classList.remove("is-active");
                  });
                var s = this.element.querySelector(
                  "#".concat(i.getAttribute("aria-controls"))
                );
                this.timeline.eventCallback("onReverseComplete", function () {
                  s.setAttribute("aria-hidden", "false"),
                    g
                      .getSiblings(s, '.TabPanel[aria-hidden="false"]')
                      .forEach(function (e) {
                        e.setAttribute("aria-hidden", "true");
                      }),
                    v.matchesBreakpoint("lap-and-up") &&
                      n.carousels.forEach(function (e) {
                        e.flickityInstance.activate(),
                          e.flickityInstance.resize();
                      }),
                    n.timeline.clear(),
                    n._setupAnimation();
                }),
                  "grid" === this.options.layout &&
                  window.theme.showElementStaggering
                    ? this.timeline.reverse().timeScale(3)
                    : this.timeline.reverse();
              }
            },
          },
          {
            key: "_setupAnimation",
            value: function e() {
              var t = this;
              if (
                (this.intersectionObserver &&
                  this.intersectionObserver.disconnect(),
                (this.timeline = new TimelineLite({ delay: 0.5 })),
                "grid" === this.options.layout &&
                  window.theme.showElementStaggering)
              )
                (this.intersectionObserver = new IntersectionObserver(
                  this._reveal.bind(this)
                )),
                  g
                    .nodeListToArray(
                      this.element.querySelectorAll(
                        '.TabPanel[aria-hidden="false"] .ProductList .ProductItem'
                      )
                    )
                    .forEach(function (e) {
                      t.intersectionObserver.observe(e);
                    });
              else {
                var i = this.element.querySelector(
                  '.TabPanel[aria-hidden="false"] .ProductList'
                );
                i &&
                  this.timeline.fromTo(
                    i,
                    0.6,
                    { autoAlpha: 0, y: 25 },
                    { autoAlpha: 1, y: 0 }
                  );
              }
            },
          },
          {
            key: "_reveal",
            value: function e(t) {
              var i = this,
                n = [];
              t.forEach(function (e) {
                (e.isIntersecting || e.intersectionRatio > 0) &&
                  (n.push(e.target),
                  i.intersectionObserver.unobserve(e.target));
              }),
                0 !== n.length &&
                  this.timeline.staggerFromTo(
                    n,
                    0.45,
                    { autoAlpha: 0, y: 25 },
                    { autoAlpha: 1, y: 0 },
                    0.2
                  );
            },
          },
        ]),
        t
      );
    })(),
    Z = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          this.options.usePlaceholder ||
            (this.productVariants = new H(i, this.options));
        var n = this.element.querySelector(".Product__OffScreen");
        n && this.element.appendChild(n), this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.delegateElement.off("click"),
                this.productVariants && this.productVariants.destroy();
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              this.delegateElement.on(
                "variant:changed",
                this._updateMainImage.bind(this)
              );
            },
          },
          {
            key: "_updateMainImage",
            value: function e(t) {
              var i = t.detail.variant,
                n = t.detail.previousVariant;
              if (
                i &&
                i.featured_image &&
                (!n.featured_image ||
                  n.featured_image.id !== i.featured_image.id)
              ) {
                var s = i.featured_image,
                  a = this.element.querySelector(
                    ".FeaturedProduct__Gallery .AspectRatio"
                  );
                a.style.cssText = "max-width: "
                  .concat(s.width, "px; --aspect-ratio: ")
                  .concat(s.width / s.height);
                var o = document.createElement("img");
                o.classList.add("Image--lazyLoad"),
                  o.setAttribute(
                    "data-src",
                    $.getSizedImageUrl(s.src, "1x1").replace(
                      "_1x1.",
                      "_{width}x."
                    )
                  ),
                  o.setAttribute(
                    "data-widths",
                    "[".concat(
                      $.getSupportedSizes(
                        s,
                        [200, 400, 600, 700, 800, 900, 1e3]
                      ).join(","),
                      "]"
                    )
                  ),
                  o.setAttribute("data-sizes", "auto"),
                  a.replaceChild(o, a.querySelector("img"));
              }
            },
          },
        ]),
        t
      );
    })(),
    G = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          this._loadScript().then(this._setupPlayer.bind(this));
      }
      return (
        i(t, [
          {
            key: "_loadScript",
            value: function e() {
              var t = this;
              return new Promise(function (e, i) {
                var n = document.createElement("script");
                document.body.appendChild(n),
                  (n.onload = e),
                  (n.onerror = i),
                  (n.async = !0),
                  (n.src =
                    "youtube" === t.options.videoType
                      ? "//www.youtube.com/iframe_api"
                      : "//player.vimeo.com/api/player.js");
              });
            },
          },
          {
            key: "onUnload",
            value: function e() {
              this.player && this.player.destroy();
            },
          },
          {
            key: "_setupPlayer",
            value: function e() {
              var t = this,
                i = this.element.querySelector(".ImageHero__VideoHolder"),
                n = setInterval(function () {
                  "youtube" === t.options.videoType
                    ? window.YT &&
                      ((t.player = new YT.Player(i, {
                        videoId: t.options.videoId,
                        playerVars: {
                          showinfo: 0,
                          controls: 0,
                          fs: 0,
                          rel: 0,
                          height: "100%",
                          width: "100%",
                          iv_load_policy: 3,
                          html5: 1,
                          loop: 1,
                          playsinline: 1,
                          modestbranding: 1,
                          disablekb: 1,
                          origin: t.options.requestHost,
                        },
                        events: {
                          onReady: t._onYouTubeReady.bind(t),
                          onStateChange: t._onYouTubeStateChange.bind(t),
                        },
                      })),
                      clearInterval(n))
                    : "vimeo" === t.options.videoType &&
                      ((t.player = new Vimeo.Player(i.parentNode, {
                        id: t.options.videoId,
                        autoplay: !0,
                        autopause: !1,
                        muted: !0,
                        background: !0,
                        loop: !0,
                      })),
                      clearInterval(n));
                }, 50);
            },
          },
          {
            key: "_onYouTubeReady",
            value: function e(t) {
              this.player.mute(), this.player.playVideo();
            },
          },
          {
            key: "_onYouTubeStateChange",
            value: function e(t) {
              t.data === YT.PlayerState.ENDED && this.player.playVideo();
            },
          },
        ]),
        t
      );
    })(),
    X = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          this._createQrCode(),
          this._setupPrint();
      }
      return (
        i(t, [
          {
            key: "_createQrCode",
            value: function e() {
              var t = document.getElementById("QrCode");
              new QRCode(t, {
                text: t.getAttribute("data-identifier"),
                width: 120,
                height: 120,
              });
            },
          },
          {
            key: "_setupPrint",
            value: function e() {
              var t = document.getElementById("PrintGiftCard");
              t &&
                t.addEventListener("click", function () {
                  window.print();
                });
            },
          },
        ]),
        t
      );
    })(),
    J = (function () {
      function t(i) {
        var n = this;
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          (this.lastScrollPosition = -1),
          (this.isTouch = window.matchMedia(
            "(-moz-touch-enabled: 1), (hover: none)"
          ).matches),
          this.options.isSticky && Stickyfill.addOne(this.element.parentNode),
          (this.searchBar = new D()),
          this._attachListeners(),
          this._verifyNavigationOverlap();
        var s = this.element.querySelector(".Header__LogoImage--primary");
        s && !s.complete
          ? s.addEventListener("load", function () {
              fastdom.measure(function () {
                document.documentElement.style.setProperty(
                  "--header-height",
                  n.element.clientHeight + "px"
                ),
                  document.documentElement.style.setProperty(
                    "--header-is-not-transparent",
                    n.options.hasTransparentHeader ? 0 : 1
                  );
              });
            })
          : fastdom.measure(function () {
              document.documentElement.style.setProperty(
                "--header-height",
                n.element.clientHeight + "px"
              ),
                document.documentElement.style.setProperty(
                  "--header-is-not-transparent",
                  n.options.hasTransparentHeader ? 0 : 1
                );
            }),
          window.addEventListener(
            "pageshow",
            this._checkTransparentHeader.bind(this)
          ),
          this._setupLocalizationPopovers();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.element.removeEventListener(
                "mouseleave",
                this._closeNavigationListener
              ),
                this.element.removeEventListener(
                  "mouseenter",
                  this._focusNavigationListener
                ),
                this.element.removeEventListener(
                  "focusin",
                  this._focusNavigationListener
                ),
                this.delegateElement.off(),
                window.removeEventListener(
                  "scroll",
                  this._checkTransparentHeaderListener
                ),
                window.removeEventListener(
                  "resize",
                  this._verifyNavigationOverlapListener
                ),
                this.options.isSticky &&
                  Stickyfill.removeOne(this.element.parentNode),
                this.searchBar.destroy(),
                this.localizationPopovers.forEach(function (e) {
                  e.destroy();
                });
            },
          },
          {
            key: "onSelect",
            value: function e() {
              this._checkTransparentHeader();
            },
          },
          {
            key: "onBlockSelect",
            value: function e(t) {
              var i = this,
                n = t.target.closest(".HorizontalList__Item");
              fastdom.mutate(function () {
                t.target.setAttribute("aria-hidden", "false"),
                  n &&
                    (n.classList.add("is-expanded"),
                    g.getSiblings(n, ".is-expanded").forEach(function (e) {
                      e.classList.remove("is-expanded");
                    })),
                  i.element.classList.remove("Header--transparent");
              });
            },
          },
          {
            key: "onBlockDeselect",
            value: function e(t) {
              var i = t.target.closest(".HorizontalList__Item");
              fastdom.mutate(function () {
                t.target.setAttribute("aria-hidden", "true"),
                  i && i.classList.remove("is-expanded");
              }),
                this._checkTransparentHeader();
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._checkTransparentHeaderListener =
                this._checkTransparentHeader.bind(this)),
                (this._closeNavigationListener =
                  this._closeNavigation.bind(this)),
                (this._focusNavigationListener =
                  this._focusNavigation.bind(this)),
                (this._verifyNavigationOverlapListener =
                  this._verifyNavigationOverlap.bind(this)),
                this.element.addEventListener(
                  "mouseleave",
                  this._closeNavigationListener
                ),
                this.delegateElement.on(
                  "mouseenter",
                  ".Header__MainNav .HorizontalList__Item, [aria-haspopup]",
                  this._openMenu.bind(this),
                  !0
                ),
                this.delegateElement.on(
                  "focusin",
                  "[aria-haspopup]",
                  this._openMenu.bind(this),
                  !0
                ),
                this.delegateElement.on(
                  "focusout",
                  "[aria-haspopup]",
                  this._closeMenu.bind(this),
                  !1
                ),
                this.delegateElement.on(
                  "click",
                  '[data-action="toggle-search"]',
                  this._closeNavigationListener
                ),
                this.delegateElement.on(
                  "mouseleave",
                  ".DropdownMenu [aria-haspopup]",
                  this._closeMenu.bind(this),
                  !0
                ),
                this.delegateElement.on(
                  "mouseenter",
                  ".DropdownMenu [aria-haspopup]",
                  this._adjustDropdownPosition.bind(this),
                  !0
                ),
                this.isTouch &&
                  this.delegateElement.on(
                    "click",
                    ".Header__MainNav [aria-haspopup]",
                    this._handleTouchMenu.bind(this)
                  ),
                this.options.hasTransparentHeader &&
                  (this.element.addEventListener(
                    "mouseenter",
                    this._focusNavigationListener
                  ),
                  this.element.addEventListener(
                    "focusin",
                    this._focusNavigationListener
                  )),
                this.options.isSticky &&
                  this.options.hasTransparentHeader &&
                  window.addEventListener(
                    "scroll",
                    this._checkTransparentHeaderListener
                  ),
                ("inline" === this.options.navigationStyle ||
                  "logoLeft" === this.options.navigationStyle) &&
                  window.addEventListener(
                    "resize",
                    this._verifyNavigationOverlapListener
                  );
            },
          },
          {
            key: "_setupLocalizationPopovers",
            value: function e() {
              (this.localizationPopovers = []),
                g
                  .nodeListToArray(
                    document.querySelectorAll("#header-locale-popover")
                  )
                  .forEach(function (e, t) {
                    e.id = "".concat(e.id, "-").concat(t);
                  }),
                g
                  .nodeListToArray(
                    document.querySelectorAll(
                      '[aria-controls="header-locale-popover"]'
                    )
                  )
                  .forEach(function (e, t) {
                    e.setAttribute(
                      "aria-controls",
                      "".concat(e.getAttribute("aria-controls"), "-").concat(t)
                    );
                  }),
                g
                  .nodeListToArray(
                    document.querySelectorAll("#header-currency-popover")
                  )
                  .forEach(function (e, t) {
                    e.id = "".concat(e.id, "-").concat(t);
                  }),
                g
                  .nodeListToArray(
                    document.querySelectorAll(
                      '[aria-controls="header-currency-popover"]'
                    )
                  )
                  .forEach(function (e, t) {
                    e.setAttribute(
                      "aria-controls",
                      "".concat(e.getAttribute("aria-controls"), "-").concat(t)
                    );
                  });
              var t = document.getElementById("header-locale-popover-0");
              t &&
                this.localizationPopovers.push(
                  new E(t, {
                    preferredAlignment: "center",
                    preferredPosition: "bottom",
                    threshold: 12,
                  })
                );
              var i = document.getElementById("header-locale-popover-1");
              i &&
                this.localizationPopovers.push(
                  new E(i, {
                    preferredAlignment: "center",
                    preferredPosition: "bottom",
                    threshold: 12,
                  })
                );
              var n = document.getElementById("header-currency-popover-0");
              n &&
                this.localizationPopovers.push(
                  new E(n, {
                    preferredAlignment: "center",
                    preferredPosition: "bottom",
                    threshold: 12,
                  })
                );
              var s = document.getElementById("header-currency-popover-1");
              s &&
                this.localizationPopovers.push(
                  new E(s, {
                    preferredAlignment: "center",
                    preferredPosition: "bottom",
                    threshold: 12,
                  })
                );
            },
          },
          {
            key: "_focusNavigation",
            value: function e() {
              var t = this;
              fastdom.mutate(function () {
                (!t.isTouch || v.matchesBreakpoint("desk")) &&
                  t.element.classList.remove("Header--transparent");
              });
            },
          },
          {
            key: "_closeNavigation",
            value: function e() {
              var t = this;
              fastdom.mutate(function () {
                g
                  .nodeListToArray(t.element.querySelectorAll(".is-expanded"))
                  .forEach(function (e) {
                    e.classList.remove("is-expanded");
                  }),
                  g
                    .nodeListToArray(
                      t.element.querySelectorAll(
                        '.Header__MainNav [aria-hidden="false"]'
                      )
                    )
                    .forEach(function (e) {
                      e.setAttribute("aria-hidden", "true");
                    });
              }),
                this.options.hasTransparentHeader &&
                  this._checkTransparentHeader();
            },
          },
          {
            key: "_openMenu",
            value: function e(t, i) {
              ("mouseenter" !== t.type || i === t.target) &&
                fastdom.mutate(function () {
                  i.classList.add("is-expanded"),
                    g
                      .nodeListToArray(
                        i.children,
                        '.Header__MainNav [aria-hidden="true"]'
                      )
                      .forEach(function (e) {
                        e.setAttribute("aria-hidden", "false");
                      }),
                    g.getSiblings(i, ".is-expanded").forEach(function (e) {
                      e.classList.remove("is-expanded"),
                        g
                          .nodeListToArray(
                            e.children,
                            '.Header__MainNav [aria-hidden="false"]'
                          )
                          .forEach(function (e) {
                            e.setAttribute("aria-hidden", "true");
                          });
                    });
                });
            },
          },
          {
            key: "_closeMenu",
            value: function e(t, i) {
              ("mouseleave" !== t.type || i === t.target) &&
                fastdom.mutate(function () {
                  i.classList.remove("is-expanded"),
                    g
                      .nodeListToArray(
                        i.children,
                        '.Header__MainNav [aria-hidden="false"]'
                      )
                      .forEach(function (e) {
                        e.setAttribute("aria-hidden", "true");
                      });
                });
            },
          },
          {
            key: "_adjustDropdownPosition",
            value: function e(t, i) {
              var n = g.nodeListToArray(i.querySelectorAll(".DropdownMenu")),
                s = !1;
              fastdom.measure(function () {
                var e = window.innerWidth,
                  t = i.getBoundingClientRect().right;
                n.forEach(function (i) {
                  t + i.offsetWidth > e && (s = !0);
                });
              }),
                fastdom.mutate(function () {
                  s
                    ? n.forEach(function (e) {
                        e.classList.add("DropdownMenu--reversed");
                      })
                    : n.forEach(function (e) {
                        e.classList.remove("DropdownMenu--reversed");
                      });
                });
            },
          },
          {
            key: "_handleTouchMenu",
            value: function e(t, i) {
              i.classList.contains("is-expanded") || t.preventDefault();
            },
          },
          {
            key: "_verifyNavigationOverlap",
            value: function e() {
              var t = this,
                i = !1,
                n = this.element.querySelector(".Header__MainNav");
              fastdom.measure(function () {
                if (n) {
                  var e = g.outerHeightWithMargin(
                    n.querySelector(".HorizontalList__Item")
                  );
                  n.scrollHeight > e && (i = !0);
                }
              }),
                this.element.classList.remove(
                  "Header--logoLeft",
                  "Header--inline",
                  "Header--center"
                ),
                this.element.classList.add(
                  "Header--".concat(this.options.navigationStyle)
                ),
                this.element.clientWidth,
                fastdom.mutate(function () {
                  if (i) {
                    if (
                      (t.element.classList.remove(
                        "Header--".concat(t.options.navigationStyle)
                      ),
                      t.element.classList.add("Header--center"),
                      n)
                    ) {
                      var e = new Set();
                      Array.from(
                        n.querySelectorAll(".HorizontalList__Item")
                      ).forEach(function (t) {
                        e.add(t.getBoundingClientRect().top);
                      }),
                        (i = e.size > 1);
                    }
                  } else t.element.classList.add("Header--".concat(t.options.navigationStyle)), t.element.classList.remove("Header--center");
                  t.element
                    .querySelector(".Header__FlexItem--logo")
                    .classList.toggle("Header__FlexItem--increaseSpace", i),
                    t.element.classList.add("Header--initialized"),
                    fastdom.measure(function () {
                      document.documentElement.style.setProperty(
                        "--header-height",
                        t.element.clientHeight + "px"
                      );
                    });
                });
            },
          },
          {
            key: "_checkTransparentHeader",
            value: function e() {
              var t = this;
              this.options.hasTransparentHeader &&
                (fastdom.measure(function () {
                  t.lastScrollPosition = window.pageYOffset;
                }),
                fastdom.mutate(function () {
                  t.lastScrollPosition <= 10
                    ? t.element.classList.add("Header--transparent")
                    : t.element.classList.remove("Header--transparent");
                }));
            },
          },
        ]),
        t
      );
    })(),
    ee = (function () {
      function t(i) {
        e(this, t), (this.element = i);
        var n = document.getElementById("footer-locale-popover");
        n &&
          (this.localePopover = new E(n, {
            preferredAlignment: "center",
            preferredPosition: "top",
            threshold: 12,
          }));
        var s = document.getElementById("footer-currency-popover");
        s &&
          (this.currencyPopover = new E(s, {
            preferredAlignment: "center",
            preferredPosition: "top",
            threshold: 12,
          }));
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.localePopover && this.localePopover.destroy(),
                this.currencyPopover && this.currencyPopover.destroy();
            },
          },
        ]),
        t
      );
    })(),
    et = (function () {
      function t(i) {
        e(this, t), (this.element = i);
      }
      return i(t, [{ key: "onUnload", value: function e() {} }]), t;
    })(),
    ei = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.timelineLite = new TimelineLite()),
          (this.customerLoginForm =
            this.element.querySelector("#customer_login")),
          (this.recoverPasswordForm = this.element.querySelector(
            "#recover_customer_password"
          )),
          this.delegateElement.on(
            "click",
            '[data-action="toggle-recover-form"]',
            this._showRecoverPassword.bind(this)
          );
      }
      return (
        i(t, [
          {
            key: "_showRecoverPassword",
            value: function e() {
              "block" === this.customerLoginForm.style.display
                ? this.timelineLite
                    .fromTo(
                      this.customerLoginForm,
                      0.5,
                      { autoAlpha: 1, display: "block", y: 0 },
                      { autoAlpha: 0, y: 20, display: "none" }
                    )
                    .fromTo(
                      this.recoverPasswordForm,
                      0.5,
                      { autoAlpha: 0, display: "none", y: 20 },
                      { autoAlpha: 1, display: "block", y: 0, delay: 0.25 }
                    )
                : this.timelineLite
                    .fromTo(
                      this.recoverPasswordForm,
                      0.5,
                      { autoAlpha: 1, display: "block", y: 0 },
                      { autoAlpha: 0, y: 20, display: "none" }
                    )
                    .fromTo(
                      this.customerLoginForm,
                      0.5,
                      { autoAlpha: 0, display: "none", y: 20 },
                      { autoAlpha: 1, display: "block", y: 0, delay: 0.25 }
                    );
            },
          },
        ]),
        t
      );
    })(),
    en = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.options = JSON.parse(i.getAttribute("data-section-settings"))),
          this.options.apiKey &&
            this.options.mapAddress &&
            this._loadScript().then(this._initMap.bind(this));
      }
      return (
        i(t, [
          {
            key: "_loadScript",
            value: function e() {
              var t = this;
              return new Promise(function (e, i) {
                var n = document.createElement("script");
                document.body.appendChild(n),
                  (n.onload = e),
                  (n.onerror = i),
                  (n.async = !0),
                  (n.src =
                    "https://maps.googleapis.com/maps/api/js?key=".concat(
                      t.options.apiKey
                    ));
              });
            },
          },
          {
            key: "_initMap",
            value: function e() {
              var t = this;
              new google.maps.Geocoder().geocode(
                { address: this.options.mapAddress },
                function (e, i) {
                  if (i !== google.maps.GeocoderStatus.OK) Shopify.designMode;
                  else {
                    var n = {
                        zoom: t.options.zoom,
                        center: e[0].geometry.location,
                        draggable: !1,
                        clickableIcons: !1,
                        scrollwheel: !1,
                        disableDoubleClickZoom: !0,
                        disableDefaultUI: !0,
                      },
                      s = new google.maps.Map(
                        t.element.querySelector(".FeaturedMap__GMap"),
                        n
                      ),
                      a = s.getCenter();
                    s.setCenter(a);
                    var o = {
                      path: "M32.7374478,5.617 C29.1154478,1.995 24.2994478,0 19.1774478,0 C14.0544478,0 9.23944778,1.995 5.61744778,5.617 C-1.08555222,12.319 -1.91855222,24.929 3.81344778,32.569 L19.1774478,54.757 L34.5184478,32.6 C40.2734478,24.929 39.4404478,12.319 32.7374478,5.617 Z M19.3544478,26 C15.4954478,26 12.3544478,22.859 12.3544478,19 C12.3544478,15.141 15.4954478,12 19.3544478,12 C23.2134478,12 26.3544478,15.141 26.3544478,19 C26.3544478,22.859 23.2134478,26 19.3544478,26 Z",
                      fillColor: t.options.markerColor,
                      fillOpacity: 1,
                      anchor: new google.maps.Point(15, 55),
                      strokeWeight: 0,
                      scale: 0.6,
                    };
                    new google.maps.Marker({
                      map: s,
                      position: s.getCenter(),
                      icon: o,
                    });
                    var r = new google.maps.StyledMapType(
                      JSON.parse(
                        t.element.querySelector("[data-gmap-style]").innerHTML
                      )
                    );
                    s.mapTypes.set("styled_map", r),
                      s.setMapTypeId("styled_map"),
                      google.maps.event.addDomListener(
                        window,
                        "resize",
                        function () {
                          google.maps.event.trigger(s, "resize"),
                            s.setCenter(a);
                        }
                      );
                  }
                }
              );
            },
          },
        ]),
        t
      );
    })(),
    es = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = JSON.parse(i.getAttribute("data-section-settings")));
        try {
          "#newsletter-popup" === window.location.hash &&
          null !== window.theme.pageType
            ? this._openPopup()
            : (!this.options.showOnlyOnce ||
                (this.options.showOnlyOnce &&
                  null === localStorage.getItem("themePopup"))) &&
              setTimeout(
                this._openPopup.bind(this),
                1e3 * this.options.apparitionDelay
              );
        } catch (n) {}
        this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.delegateElement.off();
            },
          },
          {
            key: "onSelect",
            value: function e() {
              this._openPopup();
            },
          },
          {
            key: "onDeselect",
            value: function e() {
              this._closePopup();
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              this.delegateElement.on(
                "click",
                '[data-action="close-popup"]',
                this._closePopup.bind(this)
              );
            },
          },
          {
            key: "_openPopup",
            value: function e() {
              this.element.setAttribute("aria-hidden", "false"),
                localStorage.setItem("themePopup", "true");
            },
          },
          {
            key: "_closePopup",
            value: function e() {
              this.element.setAttribute("aria-hidden", "true");
            },
          },
        ]),
        t
      );
    })(),
    ea = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          this.options.useRecommendations
            ? this._loadRecommendations().then(this._createSlideshow.bind(this))
            : this._createSlideshow();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.carousel.destroy();
            },
          },
          {
            key: "_loadRecommendations",
            value: function e() {
              var t = this;
              return fetch(
                ""
                  .concat(
                    window.routes.productRecommendationsUrl,
                    "?section_id="
                  )
                  .concat(
                    this.element.getAttribute("data-section-id"),
                    "&product_id="
                  )
                  .concat(this.options.productId, "&limit=")
                  .concat(this.options.recommendationsCount)
              ).then(function (e) {
                return e.text().then(function (e) {
                  var i = document.createElement("div");
                  (i.innerHTML = e),
                    (t.element.querySelector(
                      ".ProductRecommendations"
                    ).innerHTML = i.querySelector(
                      ".ProductRecommendations"
                    ).innerHTML);
                });
              });
            },
          },
          {
            key: "_createSlideshow",
            value: function e() {
              var t = this.element.querySelector("[data-flickity-config]");
              t && ((this.carousel = new f(t)), new A(this.element));
            },
          },
        ]),
        t
      );
    })(),
    eo = (function () {
      function t(i) {
        var n = this;
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          (this.viewInSpaceElement =
            this.element.querySelector("[data-shopify-xr]")),
          (this.productVariants = new H(i, this.options)),
          (this.productReviews = new T(i));
        var s = this.element.querySelector(".Product__Slideshow");
        s &&
          ((this.productSlideshow = new f(
            s,
            {
              onSelect: this._onImageChanged.bind(this),
              onSettle: this._onImageSettled.bind(this),
            },
            { draggable: !v.matchesBreakpoint("supports-hover") }
          )),
          (this.mediaList = {}),
          (this.previouslySelectedMedia = null),
          s.querySelectorAll('[data-media-type="model"]').forEach(function (e) {
            n.mediaList[e.getAttribute("data-media-id")] = new P(
              e,
              n.options.stackProductImages
            );
          }),
          s
            .querySelectorAll(
              '[data-media-type="video"], [data-media-type="external_video"]'
            )
            .forEach(function (e) {
              n.mediaList[e.getAttribute("data-media-id")] = new O(
                e,
                n.options.stackProductImages,
                n.options.enableVideoLooping
              );
            }),
          this.options.stackProductImages &&
            ((this.slideshowNavDots = this.element.querySelector(
              ".Product__SlideshowNav--dots"
            )),
            (this.slideshowNavDotsItems = this.slideshowNavDots
              ? g.nodeListToArray(this.slideshowNavDots.querySelectorAll("a"))
              : [])),
          this.options.showThumbnails &&
            ((this.slideshowNavThumbnails = this.element.querySelector(
              ".Product__SlideshowNav--thumbnails"
            )),
            (this.slideshowNavThumbnailsItems = this.slideshowNavThumbnails
              ? g.nodeListToArray(
                  this.slideshowNavThumbnails.querySelectorAll(
                    ".Product__SlideshowNavImage"
                  )
                )
              : [])),
          (this.slideshowImages = g.nodeListToArray(
            s.querySelectorAll(".Carousel__Cell")
          )),
          this._setupSlideshowMobileNav()),
          (this.productWrapperElement =
            this.element.querySelector(".Product__Wrapper")),
          (this.productInfoElement =
            this.element.querySelector(".Product__Info")),
          (this.productAsideElement =
            this.element.querySelector(".Product__Aside")),
          (this.productGalleryElement =
            this.element.querySelector(".Product__Gallery")),
          (this.quickNav = this.element.querySelector(".Product__QuickNav")),
          this.options.enableImageZoom &&
            (this.imageZoomInstance = new C(
              this.element,
              this.productSlideshow
            )),
          Stickyfill.addOne(this.productInfoElement);
        var a = this.element.querySelector(".Product__OffScreen");
        a && this.element.appendChild(a),
          this._setupDeviceFeatures(),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.delegateElement.off("click"),
                this.productReviews.destroy(),
                this.productVariants && this.productVariants.destroy(),
                this.productSlideshow && this.productSlideshow.destroy(),
                this.options.enableImageZoom &&
                  this.imageZoomInstance.destroy(),
                this.carouselNavScrollSpy &&
                  this.carouselNavScrollSpy.destroy(),
                this.quickNav &&
                  window.removeEventListener(
                    "scroll",
                    this._checkQuickNavListener
                  ),
                this.productInfoScroller && this.productInfoScroller.destroy(),
                this.productThumbnailsScroller &&
                  this.productThumbnailsScroller.destroy(),
                window.ResizeObserver &&
                  this.productInfoResizeObserver &&
                  this.productInfoResizeObserver.disconnect(),
                Stickyfill.removeOne(this.productInfoElement),
                document.removeEventListener(
                  "breakpoint:changed",
                  this._onBreakpointChangedListener
                );
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._onBreakpointChangedListener =
                this._setupDeviceFeatures.bind(this)),
                (this._checkQuickNavListener = this._checkQuickNav.bind(this)),
                this.delegateElement.on(
                  "click",
                  '[data-action="toggle-social-share"]',
                  this._toggleSocialShare.bind(this)
                ),
                this.delegateElement.on(
                  "variant:changed",
                  this._updateSlideshowImage.bind(this)
                ),
                this.delegateElement.on(
                  "scrollspy:target:changed",
                  this._onScrollTargetChanged.bind(this)
                ),
                this.delegateElement.on(
                  "model:played",
                  this._onMediaPlayed.bind(this)
                ),
                this.delegateElement.on(
                  "video:played",
                  this._onMediaPlayed.bind(this)
                ),
                this.delegateElement.on(
                  "model:paused",
                  this._onMediaPaused.bind(this)
                ),
                this.delegateElement.on(
                  "video:paused",
                  this._onMediaPaused.bind(this)
                ),
                document.addEventListener(
                  "breakpoint:changed",
                  this._onBreakpointChangedListener
                ),
                this.quickNav &&
                  window.addEventListener(
                    "scroll",
                    this._checkQuickNavListener
                  ),
                !this.options.stackProductImages &&
                  this.options.showThumbnails &&
                  this.delegateElement.on(
                    "click",
                    ".Product__SlideshowNavImage",
                    this._switchToImage.bind(this)
                  );
            },
          },
          {
            key: "_setupSlideshowMobileNav",
            value: function e() {
              var t = this;
              if (
                ((this.slideshowMobileNav = this.element.querySelector(
                  ".Product__SlideshowMobileNav"
                )),
                this.slideshowMobileNav)
              ) {
                var i = new domDelegate.Delegate(this.slideshowMobileNav);
                i.on("click", ".dot", function (e, i) {
                  t._slideWillChange(),
                    t.productSlideshow.selectCell(
                      parseInt(i.getAttribute("data-index"))
                    );
                }),
                  i.on("click", ".Product__SlideshowNavArrow", function (e, i) {
                    t._slideWillChange(),
                      "next" === i.getAttribute("data-direction")
                        ? t.productSlideshow.next()
                        : t.productSlideshow.previous();
                  });
              }
            },
          },
          {
            key: "_updateSlideshowImage",
            value: function e(t) {
              var i = t.detail.variant,
                n = t.detail.previousVariant;
              if (
                i &&
                i.featured_media &&
                (!n ||
                  !n.featured_media ||
                  n.featured_media.id !== i.featured_media.id)
              ) {
                if (
                  (this._slideWillChange(),
                  v.matchesBreakpoint("pocket") ||
                    !this.options.stackProductImages)
                )
                  for (
                    var s = 0;
                    s !== this.productSlideshow.flickityInstance.cells.length;
                    ++s
                  ) {
                    var a =
                      this.productSlideshow.flickityInstance.cells[s].element;
                    parseInt(a.getAttribute("data-media-id")) ===
                      i.featured_media.id &&
                      this.productSlideshow.selectCell(
                        parseInt(a.getAttribute("data-media-position")) - 1
                      );
                  }
                else
                  document
                    .querySelector(
                      '[href="#Media'.concat(i.featured_media.id, '"]')
                    )
                    .click();
              }
            },
          },
          {
            key: "_onMediaPlayed",
            value: function e(t) {
              (this.productSlideshow.getFlickityInstance().options.draggable =
                !1),
                this.productSlideshow.getFlickityInstance().unbindDrag(),
                this.previouslySelectedMedia &&
                  this.previouslySelectedMedia !== t.target &&
                  this.mediaList[
                    this.previouslySelectedMedia.getAttribute("data-media-id")
                  ].hasBeenDeselected(),
                this.options.stackProductImages &&
                  (this.previouslySelectedMedia = t.target);
            },
          },
          {
            key: "_onMediaPaused",
            value: function e() {
              (this.productSlideshow.getFlickityInstance().options.draggable =
                !v.matchesBreakpoint("supports-hover")),
                this.productSlideshow.getFlickityInstance().bindDrag();
            },
          },
          {
            key: "_handleMedia",
            value: function e(t) {
              if (
                this.previouslySelectedMedia &&
                this.previouslySelectedMedia !== t
              ) {
                switch (
                  this.previouslySelectedMedia.getAttribute("data-media-type")
                ) {
                  case "video":
                  case "external_video":
                  case "model":
                    this.mediaList[
                      this.previouslySelectedMedia.getAttribute("data-media-id")
                    ].hasBeenDeselected();
                }
                "model" ===
                  this.previouslySelectedMedia.getAttribute(
                    "data-media-type"
                  ) &&
                  this.viewInSpaceElement &&
                  this.viewInSpaceElement.setAttribute(
                    "data-shopify-model3d-id",
                    this.viewInSpaceElement.getAttribute(
                      "data-shopify-model3d-default-id"
                    )
                  );
              }
              switch (t.getAttribute("data-media-type")) {
                case "video":
                case "external_video":
                case "model":
                  this.mediaList[
                    t.getAttribute("data-media-id")
                  ].hasBeenSelected();
              }
              "model" === t.getAttribute("data-media-type") &&
                this.viewInSpaceElement &&
                this.viewInSpaceElement.setAttribute(
                  "data-shopify-model3d-id",
                  t.getAttribute("data-media-id")
                ),
                (this.previouslySelectedMedia = t);
            },
          },
          {
            key: "_onScrollTargetChanged",
            value: function e(t) {
              this.options.stackProductImages &&
                (this.slideshowNavDotsItems.forEach(function (e) {
                  return e.classList.remove("is-selected");
                }),
                this.slideshowNavDotsItems[
                  parseInt(
                    t.detail.newTarget.getAttribute("data-media-position")
                  ) - 1
                ].classList.add("is-selected"),
                this.options.showThumbnails &&
                  (this.slideshowNavThumbnailsItems.forEach(function (e) {
                    return e.classList.remove("is-selected");
                  }),
                  this.slideshowNavThumbnailsItems[
                    parseInt(
                      t.detail.newTarget.getAttribute("data-media-position")
                    ) - 1
                  ].classList.add("is-selected")));
            },
          },
          {
            key: "_switchToImage",
            value: function e(t, i) {
              t.preventDefault(), this._slideWillChange();
              for (
                var n = 0;
                n !== this.productSlideshow.flickityInstance.cells.length;
                ++n
              ) {
                var s = this.productSlideshow.flickityInstance.cells[n].element;
                parseInt(s.getAttribute("data-media-id")) ===
                  parseInt(i.getAttribute("data-media-id")) &&
                  this.productSlideshow.selectCell(
                    parseInt(s.getAttribute("data-media-position")) - 1
                  );
              }
            },
          },
          {
            key: "_checkQuickNav",
            value: function e() {
              var t = this,
                i = !1;
              fastdom.measure(function () {
                i =
                  window.scrollY >=
                  t.productAsideElement.offsetTop -
                    t.productAsideElement.clientHeight;
              }),
                fastdom.mutate(function () {
                  i
                    ? t.quickNav.classList.add("is-flipped")
                    : t.quickNav.classList.remove("is-flipped");
                });
            },
          },
          {
            key: "_toggleSocialShare",
            value: function e(t, i) {
              i.classList.toggle("is-active"),
                i.classList.toggle("RoundButton--secondaryState"),
                i.setAttribute(
                  "aria-expanded",
                  "true" === i.getAttribute("aria-expanded") ? "false" : "true"
                ),
                i.nextElementSibling.setAttribute(
                  "aria-hidden",
                  "true" === i.nextElementSibling.getAttribute("aria-hidden")
                    ? "false"
                    : "true"
                );
            },
          },
          {
            key: "_onImageChanged",
            value: function e(t, i) {
              if (v.matchesBreakpoint("pocket")) {
                var n = this.element.querySelector(
                  ".Product__Gallery .Product__ActionList"
                );
                n &&
                  (i.classList.contains("Product__SlideItem--image")
                    ? n.classList.remove("is-hidden")
                    : n.classList.add("is-hidden"));
              }
              if (
                !this.options.stackProductImages &&
                this.options.showThumbnails
              ) {
                var s = i.getAttribute("data-media-id");
                this.slideshowNavThumbnailsItems.forEach(function (e) {
                  e.getAttribute("data-media-id") === s
                    ? e.classList.add("is-selected")
                    : e.classList.remove("is-selected");
                });
              }
              if (this.slideshowMobileNav) {
                var a = parseInt(i.getAttribute("data-media-position")) - 1;
                g.nodeListToArray(
                  this.slideshowMobileNav.querySelectorAll(".dot")
                ).forEach(function (e, t) {
                  t === a
                    ? e.classList.add("is-selected")
                    : e.classList.remove("is-selected");
                });
              }
            },
          },
          {
            key: "_onImageSettled",
            value: function e(t, i) {
              this._handleMedia(i),
                v.matchesBreakpoint("lap-and-up") &&
                  this.element
                    .querySelectorAll(".Product__SlideItem:not(.is-selected)")
                    .forEach(function (e) {
                      e.classList.add("Product__SlideItem--hidden");
                    });
            },
          },
          {
            key: "_slideWillChange",
            value: function e() {
              v.matchesBreakpoint("lap-and-up") &&
                this.element
                  .querySelectorAll(".Product__SlideItem")
                  .forEach(function (e) {
                    e.classList.remove("Product__SlideItem--hidden");
                  });
            },
          },
          {
            key: "_setupDeviceFeatures",
            value: function e(t) {
              var i = this,
                n = t ? t.detail.currentBreakpoint : v.getCurrentBreakpoint();
              if (n !== (t ? t.detail.previousBreakpoint : null)) {
                if ("phone" === n || "tablet" === n)
                  this.carouselNavScrollSpy &&
                    this.carouselNavScrollSpy.destroy(),
                    this.productInfoScroller &&
                      this.productInfoScroller.destroy(),
                    this.productThumbnailsScroller &&
                      this.productThumbnailsScroller.destroy(),
                    this.productAsideElement
                      ? (this.productAsideElement.style.minHeight = null)
                      : (this.productWrapperElement.style.minHeight = null),
                    (this.productInfoElement.parentNode.style.maxHeight = null);
                else {
                  if (this.slideshowImages && this.slideshowImages.length > 1) {
                    var s = 0;
                    this.options.stackProductImages &&
                      this.slideshowNavDots &&
                      (s = this.slideshowNavDots.firstElementChild.offsetTop),
                      this.options.showThumbnails &&
                        v.matchesBreakpoint("desk") &&
                        (s = 250),
                      (this.carouselNavScrollSpy = new B(
                        this.element,
                        this.slideshowImages,
                        { rootMargin: "-".concat(s, "px 0px 0px 0px") }
                      ));
                  }
                  var a = window.getComputedStyle(this.productInfoElement),
                    o = parseInt(a.paddingTop) + parseInt(a.paddingBottom),
                    r = this.productGalleryElement
                      ? parseInt(this.productGalleryElement.scrollHeight)
                      : 0,
                    l = function e() {
                      i.productAsideElement
                        ? ((i.productAsideElement.style.minHeight = "".concat(
                            i.productInfoElement.scrollHeight - o - r,
                            "px"
                          )),
                          (i.productInfoElement.closest(
                            ".Product__InfoWrapper"
                          ).style.maxHeight =
                            i.productAsideElement.offsetTop +
                            i.productInfoElement.scrollHeight -
                            o +
                            "px"))
                        : (i.productWrapperElement.style.minHeight = "".concat(
                            i.productInfoElement.scrollHeight -
                              parseInt(a.paddingTop),
                            "px"
                          ));
                    };
                  l(),
                    window.ResizeObserver &&
                      ((this.productInfoResizeObserver = new ResizeObserver(
                        function () {
                          l();
                        }
                      )),
                      this.productInfoResizeObserver.observe(
                        this.productInfoElement
                      )),
                    (this.productInfoScroller = new Y(this.productInfoElement)),
                    this.options.showThumbnails &&
                      this.slideshowNavThumbnails &&
                      (this.productThumbnailsScroller = new Y(
                        this.slideshowNavThumbnails
                      ));
                }
              }
            },
          },
        ]),
        t
      );
    })(),
    er = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.options = JSON.parse(
            this.element.getAttribute("data-section-settings")
          )),
          new A(this.element),
          this._fetchProducts();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.carousel && this.carousel.destroy();
            },
          },
          {
            key: "_fetchProducts",
            value: function e() {
              var t = this,
                i = this._getSearchQueryString();
              "" !== i &&
                fetch(
                  ""
                    .concat(window.routes.searchUrl, "?section_id=")
                    .concat(
                      this.element.getAttribute("data-section-id"),
                      "&type=product&q="
                    )
                    .concat(i),
                  { credentials: "same-origin", method: "GET" }
                ).then(function (e) {
                  e.text().then(function (e) {
                    var i = document.createElement("div");
                    (i.innerHTML = e),
                      (t.element.innerHTML =
                        i.querySelector(".Section").innerHTML),
                      (t.element.parentNode.style.display = "block"),
                      (t.carousel = new f(
                        t.element.querySelector("[data-flickity-config]")
                      ));
                  });
                });
            },
          },
          {
            key: "_getSearchQueryString",
            value: function e() {
              var t = JSON.parse(
                localStorage.getItem("recentlyViewedProducts") || "[]"
              );
              return (
                t.includes(this.options.productId) &&
                  t.splice(t.indexOf(this.options.productId), 1),
                t
                  .map(function (e) {
                    return "id:" + e;
                  })
                  .join(" OR ")
              );
            },
          },
        ]),
        t
      );
    })(),
    el = (function () {
      function t() {
        e(this, t),
          (this.constructors = []),
          (this.instances = []),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "_attachListeners",
            value: function e() {
              document.addEventListener(
                "shopify:section:load",
                this._onSectionLoad.bind(this)
              ),
                document.addEventListener(
                  "shopify:section:unload",
                  this._onSectionUnload.bind(this)
                ),
                document.addEventListener(
                  "shopify:section:select",
                  this._onSelect.bind(this)
                ),
                document.addEventListener(
                  "shopify:section:deselect",
                  this._onDeselect.bind(this)
                ),
                document.addEventListener(
                  "shopify:section:reorder",
                  this._onReorder.bind(this)
                ),
                document.addEventListener(
                  "shopify:block:select",
                  this._onBlockSelect.bind(this)
                ),
                document.addEventListener(
                  "shopify:block:deselect",
                  this._onBlockDeselect.bind(this)
                );
            },
          },
          {
            key: "register",
            value: function e(t, i) {
              var n = this;
              (this.constructors[t] = i),
                g
                  .nodeListToArray(
                    document.querySelectorAll(
                      "[data-section-type=".concat(t, "]")
                    )
                  )
                  .forEach(function (e) {
                    n._createInstance(e, i);
                  });
            },
          },
          {
            key: "_findInstance",
            value: function e(t, i, n) {
              for (var s = 0; s < t.length; s++) if (t[s][i] === n) return t[s];
            },
          },
          {
            key: "_removeInstance",
            value: function e(t, i, n) {
              for (var s = t.length; s--; )
                if (t[s][i] === n) {
                  t.splice(s, 1);
                  break;
                }
              return t;
            },
          },
          {
            key: "_onSectionLoad",
            value: function e(t) {
              var i = t.target.querySelector("[data-section-id]");
              i && this._createInstance(i);
            },
          },
          {
            key: "_onSectionUnload",
            value: function e(t) {
              var i = this._findInstance(
                this.instances,
                "id",
                t.detail.sectionId
              );
              i &&
                ("function" == typeof i.onUnload && i.onUnload(t),
                (this.instances = this._removeInstance(
                  this.instances,
                  "id",
                  t.detail.sectionId
                )));
            },
          },
          {
            key: "_onSelect",
            value: function e(t) {
              var i = this._findInstance(
                this.instances,
                "id",
                t.detail.sectionId
              );
              i && "function" == typeof i.onSelect && i.onSelect(t);
            },
          },
          {
            key: "_onDeselect",
            value: function e(t) {
              var i = this._findInstance(
                this.instances,
                "id",
                t.detail.sectionId
              );
              i && "function" == typeof i.onDeselect && i.onDeselect(t);
            },
          },
          {
            key: "_onReorder",
            value: function e(t) {
              var i = this._findInstance(
                this.instances,
                "id",
                t.detail.sectionId
              );
              i && "function" == typeof i.onReorder && i.onReorder(t);
            },
          },
          {
            key: "_onBlockSelect",
            value: function e(t) {
              var i = this._findInstance(
                this.instances,
                "id",
                t.detail.sectionId
              );
              i && "function" == typeof i.onBlockSelect && i.onBlockSelect(t);
            },
          },
          {
            key: "_onBlockDeselect",
            value: function e(t) {
              var i = this._findInstance(
                this.instances,
                "id",
                t.detail.sectionId
              );
              i &&
                "function" == typeof i.onBlockDeselect &&
                i.onBlockDeselect(t);
            },
          },
          {
            key: "_createInstance",
            value: function e(t, i) {
              var n = t.getAttribute("data-section-id"),
                s = t.getAttribute("data-section-type");
              if (void 0 !== (i = i || this.constructors[s])) {
                var a = Object.assign(new i(t), {
                  id: n,
                  type: s,
                  container: t,
                });
                this.instances.push(a);
              }
            },
          },
        ]),
        t
      );
    })(),
    ec = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.carousel = new f(
            this.element.querySelector("[data-flickity-config]")
          )),
          new A(this.element);
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.carousel.destroy();
            },
          },
        ]),
        t
      );
    })(),
    eh = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.usePocketMode = v.matchesBreakpoint("pocket")),
          (this.pocketActivatorButton = this.element.querySelector(
            '[data-action="open-look"]'
          )),
          this._createOuterCarousel(),
          this._createPocketPopovers(),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.outerCarousel.destroy(),
                this.innerCarousels.forEach(function (e) {
                  e.forEach(function (e) {
                    return e.destroy();
                  });
                }),
                this.popovers.forEach(function (e) {
                  return e.destroy();
                }),
                this.delegateElement.off();
            },
          },
          {
            key: "onBlockSelect",
            value: function e(t) {
              this.outerCarousel.selectCell(
                t.target.getAttribute("data-slide-index"),
                !0,
                !t.detail.load
              );
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              this.delegateElement.on(
                "click",
                ".ShopTheLook__Dot",
                this._onDotClicked.bind(this)
              );
            },
          },
          {
            key: "_createPocketPopovers",
            value: function e() {
              var t = this;
              (this.popovers = []),
                g
                  .nodeListToArray(this.element.querySelectorAll(".Popover"))
                  .forEach(function (e) {
                    t.popovers.push(
                      new E(e, {
                        activator: t.pocketActivatorButton,
                        showOverlay: !1,
                        onOpen: t._openPocketZoom.bind(t),
                        onClose: t._closePocketZoom.bind(t),
                      })
                    );
                  });
            },
          },
          {
            key: "_createOuterCarousel",
            value: function e() {
              var t = this;
              (this.outerCarousel = new f(
                this.element.querySelector(".ShopTheLook"),
                { onSelect: this._onLookChanged.bind(this) }
              )),
                (this.innerCarousels = Array(
                  this.outerCarousel.flickityInstance.cells.length
                ));
              for (var i = 0; i !== this.innerCarousels.length; ++i)
                this.innerCarousels[i] = [];
              g
                .nodeListToArray(
                  this.element.querySelectorAll(".ShopTheLook__ProductList")
                )
                .forEach(function (e) {
                  var i = parseInt(e.getAttribute("data-look-index"));
                  t.innerCarousels[i].push(
                    new f(e, { onSelect: t._onProductChanged.bind(t) })
                  ),
                    e.insertBefore(
                      e.querySelector(".flickity-viewport"),
                      e.querySelector(".ShopTheLook__ViewButton")
                    );
                }),
                this.outerCarousel.resize();
            },
          },
          {
            key: "_onLookChanged",
            value: function e(t, i) {
              this.pocketActivatorButton.setAttribute(
                "aria-controls",
                "".concat(i.getAttribute("id"), "-popover")
              );
            },
          },
          {
            key: "_onProductChanged",
            value: function e(t, i) {
              var n = this.outerCarousel.getSelectedCell(),
                s = null;
              g
                .nodeListToArray(n.querySelectorAll(".ShopTheLook__Dot"))
                .forEach(function (e, i) {
                  e.classList.remove("is-active"),
                    i === t && (e.classList.add("is-active"), (s = e));
                }),
                n
                  .querySelector(".ShopTheLook__ViewButton")
                  .setAttribute("href", i.getAttribute("data-product-url")),
                n.dispatchEvent(
                  new CustomEvent("product:changed", { detail: { dot: s } })
                );
            },
          },
          {
            key: "_onDotClicked",
            value: function e(t, i) {
              var n = !1,
                s = !1,
                a = this.outerCarousel.getSelectedIndex();
              this.popovers.forEach(function (e) {
                e.isOpen && ((s = !0), (n = !0));
              }),
                this.innerCarousels[a].forEach(function (e) {
                  e.selectCell(
                    parseInt(i.getAttribute("data-product-index")) - 1,
                    !1,
                    n
                  );
                }),
                this.usePocketMode && !s && this.popovers[a].open();
            },
          },
          {
            key: "_openPocketZoom",
            value: function e(t) {
              var i = this;
              this._calculateImageTransform(t),
                fastdom.mutate(function () {
                  (document.getElementById(
                    "shopify-section-header"
                  ).style.cssText =
                    "transform: translateY(-100%); transition: transform 0.3s ease-in-out;"),
                    i.outerCarousel.flickityInstance.unbindDrag(),
                    i.outerCarousel.flickityInstance.element.classList.add(
                      "is-zoomed"
                    ),
                    i.outerCarousel
                      .getSelectedCell()
                      .classList.add("is-expanded");
                });
            },
          },
          {
            key: "_calculateImageTransform",
            value: function e(t) {
              var i = this,
                n = this.outerCarousel.getSelectedCell();
              fastdom.measure(function () {
                var e =
                    window.innerWidth /
                    (n.offsetWidth -
                      2 * parseInt(window.getComputedStyle(n).paddingLeft)),
                  s = Math.round(n.offsetHeight * e),
                  a = Math.round(
                    Math.max(
                      s - (window.innerHeight - t.element.offsetHeight),
                      0
                    )
                  ),
                  o = s - a,
                  r = Math.round(
                    -(n.getBoundingClientRect().top - (s - n.offsetHeight) / 2)
                  ),
                  l = Math.round(r - a);
                (i._calculateTransformForDotListener = function (t) {
                  var n = Math.min(
                    Math.max(
                      r -
                        Math.round(
                          Math.round(
                            (t.detail.dot.offsetTop +
                              t.detail.dot.offsetHeight / 2) *
                              e
                          ) -
                            o / 2
                        ),
                      l
                    ),
                    r
                  );
                  fastdom.mutate(function () {
                    i.outerCarousel.flickityInstance.viewport.style.transform =
                      "translate3d(0, "
                        .concat(Math.round(n), "px, 0) scale(")
                        .concat(e, ")");
                  });
                }),
                  n.addEventListener(
                    "product:changed",
                    i._calculateTransformForDotListener
                  ),
                  n.dispatchEvent(
                    new CustomEvent("product:changed", {
                      detail: {
                        dot: n.querySelector(".ShopTheLook__Dot.is-active"),
                      },
                    })
                  );
              });
            },
          },
          {
            key: "_closePocketZoom",
            value: function e() {
              var t = this,
                i = this.outerCarousel.getSelectedCell();
              i.removeEventListener(
                "product:changed",
                this._calculateTransformForDotListener
              ),
                fastdom.mutate(function () {
                  (document.getElementById(
                    "shopify-section-header"
                  ).style.cssText =
                    "transform: translateY(0); transition: transform 0.3s ease-in-out 0.3s;"),
                    t.outerCarousel.flickityInstance.bindDrag(),
                    t.outerCarousel.flickityInstance.element.classList.remove(
                      "is-zoomed"
                    ),
                    (t.outerCarousel.flickityInstance.viewport.style.transform =
                      null),
                    i.classList.remove("is-expanded");
                });
            },
          },
        ]),
        t
      );
    })(),
    ed = (function () {
      function t(i) {
        e(this, t), (this.element = i), (this.sidebarDrawer = new S(i));
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.sidebarDrawer.destroy();
            },
          },
          {
            key: "onSelect",
            value: function e() {
              this.sidebarDrawer.open();
            },
          },
          {
            key: "onDeselect",
            value: function e() {
              this.sidebarDrawer.close();
            },
          },
        ]),
        t
      );
    })(),
    eu = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.slideshow = new f(
            this.element.querySelector("[data-flickity-config]"),
            { onSelect: this._onSlideChanged.bind(this) }
          )),
          (this.selectedSlide = null),
          (this.shouldAnimate = !0),
          (this.timeline = new TimelineLite({
            delay: window.theme.showPageTransition ? 0.5 : 0,
          })),
          this.slideshow.flickityInstance.cells.length > 0 &&
            this._transitionToSlide(
              this.slideshow.flickityInstance.selectedCell.element,
              !0
            ),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.slideshow.destroy(),
                this.timeline.kill(),
                this.delegateElement.off(),
                document.removeEventListener(
                  "breakpoint:changed",
                  this._onBreakpointChangedListener
                );
            },
          },
          {
            key: "onBlockSelect",
            value: function e(t) {
              this.slideshow.flickityInstance.options.autoPlay &&
                this.slideshow.flickityInstance.stopPlayer(),
                (this.shouldAnimate = !t.detail.load),
                this.slideshow.selectCell(
                  t.target.getAttribute("data-slide-index"),
                  !1,
                  !t.detail.load
                );
            },
          },
          {
            key: "onBlockDeselect",
            value: function e() {
              (this.shouldAnimate = !0),
                this.slideshow.flickityInstance.options.autoPlay &&
                  this.slideshow.flickityInstance.playPlayer();
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              (this._onBreakpointChangedListener =
                this._onBreakpointChanged.bind(this)),
                this.delegateElement.on(
                  "mouseenter",
                  ".Button",
                  this._pauseSlideshow.bind(this),
                  !0
                ),
                this.delegateElement.on(
                  "mouseleave",
                  ".Button",
                  this._resumeSlideshow.bind(this),
                  !0
                ),
                document.addEventListener(
                  "breakpoint:changed",
                  this._onBreakpointChangedListener
                );
            },
          },
          {
            key: "_pauseSlideshow",
            value: function e() {
              this.slideshow.flickityInstance.options.autoPlay &&
                this.slideshow.flickityInstance.pausePlayer();
            },
          },
          {
            key: "_resumeSlideshow",
            value: function e() {
              this.slideshow.flickityInstance.options.autoPlay &&
                this.slideshow.flickityInstance.unpausePlayer();
            },
          },
          {
            key: "_onSlideChanged",
            value: function e(t, i) {
              this._transitionToSlide(i);
            },
          },
          {
            key: "_transitionToSlide",
            value: function e(t) {
              var i = this;
              this.timeline.clear(),
                this.selectedSlide &&
                  (this._slideLeave(this.selectedSlide),
                  this.timeline.addLabel(
                    "enter",
                    this.shouldAnimate ? "-=0.4" : 0
                  )),
                this._lazyLoadNextImage(),
                this.timeline.fromTo(
                  t,
                  this.selectedSlide && this.shouldAnimate ? 0.3 : 0,
                  { autoAlpha: 0 },
                  { autoAlpha: 1, ease: Cubic.easeInOut },
                  "enter"
                ),
                this.slideshow.flickityInstance.options.autoPlay &&
                  "playing" === this.slideshow.flickityInstance.player.state &&
                  this.slideshow.flickityInstance.pausePlayer(),
                g
                  .nodeListToArray(t.querySelectorAll(".Slideshow__Image"))
                  .forEach(function (e) {
                    e.classList.contains("Image--lazyLoading") ||
                    e.classList.contains("Image--lazyLoad")
                      ? e.addEventListener(
                          "lazyloaded",
                          i._slideEnter.bind(i, t)
                        )
                      : i._slideEnter(t);
                  }),
                (this.selectedSlide = t);
            },
          },
          {
            key: "_slideLeave",
            value: function e(t) {
              var i = t.querySelector(".SectionHeader"),
                n = t.querySelector(".SectionHeader__ButtonWrapper");
              this.timeline.fromTo(
                t,
                this.shouldAnimate ? 0.3 : 0,
                { autoAlpha: 1 },
                {
                  autoAlpha: 0,
                  ease: Cubic.easeInOut,
                  delay: this.shouldAnimate ? 0.35 : 0,
                }
              ),
                i &&
                  this.timeline.fromTo(
                    i,
                    this.shouldAnimate ? 0.4 : 0,
                    { autoAlpha: 1, y: 0 },
                    { autoAlpha: 0, y: 20, ease: Cubic.easeIn },
                    0
                  ),
                n &&
                  this.timeline.fromTo(
                    n,
                    this.shouldAnimate ? 0.4 : 0,
                    { autoAlpha: 1, y: 0 },
                    { autoAlpha: 0, y: 10, ease: Cubic.easeIn },
                    0
                  );
            },
          },
          {
            key: "_slideEnter",
            value: function e(t) {
              var i = t.querySelectorAll(".Slideshow__Image"),
                n = t.querySelector(".SectionHeader"),
                s = t.querySelector(".SectionHeader__ButtonWrapper");
              this.slideshow.flickityInstance.options.autoPlay &&
                "paused" === this.slideshow.flickityInstance.player.state &&
                this.slideshow.flickityInstance.unpausePlayer(),
                window.CSS &&
                  window.CSS.supports(
                    "(object-fit: cover) or (-o-object-fit: cover)"
                  ) &&
                  (window.theme.showImageZooming
                    ? this.timeline.fromTo(
                        i,
                        this.shouldAnimate ? 1.2 : 0,
                        { opacity: 0, scale: 1.2 },
                        { opacity: 1, scale: 1, ease: Quad.easeOut },
                        "enter"
                      )
                    : this.timeline.fromTo(
                        i,
                        this.shouldAnimate ? 1.2 : 0,
                        { opacity: 0 },
                        { opacity: 1, ease: Quad.easeOut },
                        "enter"
                      )),
                n &&
                  this.timeline.fromTo(
                    n,
                    this.shouldAnimate ? 0.8 : 0,
                    { autoAlpha: 0, y: 30 },
                    {
                      autoAlpha: 1,
                      y: 0,
                      delay: this.shouldAnimate ? 0.8 : 0,
                      ease: Cubic.easeOut,
                    },
                    "enter"
                  ),
                s &&
                  this.timeline.fromTo(
                    s,
                    this.shouldAnimate ? 0.8 : 0,
                    { autoAlpha: 0, y: 20 },
                    {
                      autoAlpha: 1,
                      y: 0,
                      delay: this.shouldAnimate ? 0.8 : 0,
                      ease: Cubic.easeOut,
                    },
                    "enter"
                  );
            },
          },
          {
            key: "_lazyLoadNextImage",
            value: function e() {
              var t = this.slideshow.flickityInstance.selectedIndex,
                i = v.getCurrentBreakpoint();
              if (this.slideshow.flickityInstance.cells.length - 1 > t) {
                var n = this.slideshow.flickityInstance.cells[t + 1].element,
                  s = g.nodeListToArray(
                    n.querySelectorAll(".Slideshow__ImageContainer")
                  ),
                  a = null;
                (a = "phone" === i ? s[0] : s[1]),
                  window.lazySizes &&
                    a &&
                    a.classList.contains("Image--lazyLoad") &&
                    lazySizes.loader.unveil(a.firstElementChild);
              }
            },
          },
          {
            key: "_onBreakpointChanged",
            value: function e(t) {
              (("phone" === t.detail.previousBreakpoint &&
                "phone" !== t.detail.currentBreakpoint) ||
                ("phone" !== t.detail.previousBreakpoint &&
                  "phone" === t.detail.currentBreakpoint)) &&
                ((this.selectedSlide = null),
                this._transitionToSlide(
                  this.slideshow.flickityInstance.selectedElement
                ));
            },
          },
        ]),
        t
      );
    })(),
    ep = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.navItems = g.nodeListToArray(
            this.element.querySelectorAll(".TestimonialNav__Item")
          )),
          (this.carousel = new f(
            this.element.querySelector(".TestimonialList"),
            { onSelect: this._testimonialChanged.bind(this) }
          )),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.carousel.destroy(), this.delegateElement.off("click");
            },
          },
          {
            key: "onBlockSelect",
            value: function e(t) {
              this.carousel.selectCell(
                t.target.getAttribute("data-slide-index"),
                !0
              );
            },
          },
          {
            key: "onBlockDeselect",
            value: function e() {
              this.carousel.unpausePlayer();
            },
          },
          {
            key: "_testimonialClicked",
            value: function e(t, i) {
              this.carousel.pausePlayer(),
                this.carousel.selectCell(
                  parseInt(i.getAttribute("data-index"))
                ),
                this.carousel.unpausePlayer();
            },
          },
          {
            key: "_testimonialChanged",
            value: function e(t) {
              this.navItems.forEach(function (e, i) {
                e.classList.remove("is-selected"),
                  t === i && e.classList.add("is-selected");
              });
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              this.delegateElement.on(
                "click",
                ".TestimonialNav__Item",
                this._testimonialClicked.bind(this)
              );
            },
          },
        ]),
        t
      );
    })(),
    em = (function () {
      function t(i) {
        e(this, t),
          (this.element = i),
          (this.delegateElement = new domDelegate.Delegate(this.element)),
          (this.items = g.nodeListToArray(
            this.element.querySelectorAll(".Timeline__Item")
          )),
          (this.navItems = g.nodeListToArray(
            this.element.querySelectorAll(".Timeline__NavItem")
          )),
          this._attachListeners();
      }
      return (
        i(t, [
          {
            key: "onUnload",
            value: function e() {
              this.delegateElement.off("click");
            },
          },
          {
            key: "onBlockSelect",
            value: function e(t) {
              this.navItems[
                parseInt(t.target.getAttribute("data-index"))
              ].click();
            },
          },
          {
            key: "_attachListeners",
            value: function e() {
              this.delegateElement.on(
                "click",
                ".Timeline__NavItem",
                this._clickOnNavItem.bind(this)
              );
            },
          },
          {
            key: "_clickOnNavItem",
            value: function e(t, i) {
              var n = this.items[parseInt(i.getAttribute("data-index"))];
              if (!n.classList.contains("is-selected")) {
                var s = !1,
                  a = i.parentNode,
                  o = 0;
                fastdom.measure(function () {
                  var e = a.scrollWidth,
                    t = a.offsetWidth;
                  if ((s = t < e)) {
                    var n = i.offsetLeft,
                      r = n + i.offsetWidth,
                      l = null,
                      c =
                        (l =
                          n <= t - r
                            ? i.previousElementSibling || i
                            : i.nextElementSibling || i).offsetLeft -
                        a.scrollLeft,
                      h = c + l.offsetWidth;
                    h > t ? (o = h - t) : c < 0 && (o = c);
                  }
                }),
                  fastdom.mutate(function () {
                    s && a.scrollBy({ behavior: "smooth", left: o }),
                      i.classList.add("is-selected"),
                      g.getSiblings(i, ".is-selected").forEach(function (e) {
                        e.classList.remove("is-selected");
                      }),
                      n.classList.add("is-selected"),
                      g.getSiblings(n, ".is-selected").forEach(function (e) {
                        e.classList.remove("is-selected");
                      });
                  });
              }
            },
          },
        ]),
        t
      );
    })(),
    ev = (function (t) {
      !(function e(t, i) {
        if ("function" != typeof i && null !== i)
          throw TypeError("Super expression must either be null or a function");
        (t.prototype = Object.create(i && i.prototype, {
          constructor: { value: t, writable: !0, configurable: !0 },
        })),
          i && s(t, i);
      })(c, t);
      var o,
        r,
        l =
          ((o = c),
          (r = a()),
          function e() {
            var t,
              i,
              s,
              a = n(o);
            if (r) {
              var l = n(this).constructor;
              s = Reflect.construct(a, arguments, l);
            } else s = a.apply(this, arguments);
            return (
              (t = this),
              (i = s) && ("object" == typeof i || "function" == typeof i)
                ? i
                : (function e(t) {
                    if (void 0 === t)
                      throw ReferenceError(
                        "this hasn't been initialised - super() hasn't been called"
                      );
                    return t;
                  })(t)
            );
          });
      function c() {
        return e(this, c), l.apply(this, arguments);
      }
      return (
        i(c, [
          {
            key: "connectedCallback",
            value: function e() {
              var t = this;
              (this.rangeLowerBound = this.querySelector(
                ".price-range__range-group input:first-child"
              )),
                (this.rangeHigherBound = this.querySelector(
                  ".price-range__range-group input:last-child"
                )),
                (this.textInputLowerBound = this.querySelector(
                  ".price-range__input:first-child input"
                )),
                (this.textInputHigherBound = this.querySelector(
                  ".price-range__input:last-child input"
                )),
                this.textInputLowerBound.addEventListener("focus", function () {
                  return t.textInputLowerBound.select();
                }),
                this.textInputHigherBound.addEventListener(
                  "focus",
                  function () {
                    return t.textInputHigherBound.select();
                  }
                ),
                this.textInputLowerBound.addEventListener(
                  "change",
                  function (e) {
                    (e.target.value = Math.max(
                      Math.min(
                        parseInt(e.target.value),
                        parseInt(t.textInputHigherBound.value || e.target.max) -
                          1
                      ),
                      e.target.min
                    )),
                      (t.rangeLowerBound.value = e.target.value),
                      t.rangeLowerBound.parentElement.style.setProperty(
                        "--range-min",
                        "".concat(
                          (parseInt(t.rangeLowerBound.value) /
                            parseInt(t.rangeLowerBound.max)) *
                            100,
                          "%"
                        )
                      );
                  }
                ),
                this.textInputHigherBound.addEventListener(
                  "change",
                  function (e) {
                    (e.target.value = Math.min(
                      Math.max(
                        parseInt(e.target.value),
                        parseInt(t.textInputLowerBound.value || e.target.min) +
                          1
                      ),
                      e.target.max
                    )),
                      (t.rangeHigherBound.value = e.target.value),
                      t.rangeHigherBound.parentElement.style.setProperty(
                        "--range-max",
                        "".concat(
                          (parseInt(t.rangeHigherBound.value) /
                            parseInt(t.rangeHigherBound.max)) *
                            100,
                          "%"
                        )
                      );
                  }
                ),
                this.rangeLowerBound.addEventListener("change", function (e) {
                  (t.textInputLowerBound.value = e.target.value),
                    t.textInputLowerBound.dispatchEvent(
                      new Event("change", { bubbles: !0 })
                    );
                }),
                this.rangeHigherBound.addEventListener("change", function (e) {
                  (t.textInputHigherBound.value = e.target.value),
                    t.textInputHigherBound.dispatchEvent(
                      new Event("change", { bubbles: !0 })
                    );
                }),
                this.rangeLowerBound.addEventListener("input", function (e) {
                  (e.target.value = Math.min(
                    parseInt(e.target.value),
                    parseInt(t.textInputHigherBound.value || e.target.max) - 1
                  )),
                    e.target.parentElement.style.setProperty(
                      "--range-min",
                      "".concat(
                        (parseInt(e.target.value) / parseInt(e.target.max)) *
                          100,
                        "%"
                      )
                    ),
                    (t.textInputLowerBound.value = e.target.value);
                }),
                this.rangeHigherBound.addEventListener("input", function (e) {
                  (e.target.value = Math.max(
                    parseInt(e.target.value),
                    parseInt(t.textInputLowerBound.value || e.target.min) + 1
                  )),
                    e.target.parentElement.style.setProperty(
                      "--range-max",
                      "".concat(
                        (parseInt(e.target.value) / parseInt(e.target.max)) *
                          100,
                        "%"
                      )
                    ),
                    (t.textInputHigherBound.value = e.target.value);
                });
            },
          },
        ]),
        c
      );
    })(r(HTMLElement));
  window.customElements.define("price-range", ev),
    new b(),
    new w(),
    new v(),
    "password" !== window.theme.pageType &&
      "gift_card" !== window.theme.pageType &&
      new L(),
    (l = new el()).register("header", J),
    l.register("footer", ee),
    l.register("sidebar-menu", ed),
    l.register("cart", U),
    l.register("newsletter-popup", es),
    l.register("slideshow", eu),
    l.register("collection-list", W),
    l.register("article-list", R),
    l.register("featured-product", Z),
    l.register("image-with-text-block", et),
    l.register("timeline", em),
    l.register("map", en),
    l.register("featured-collections", K),
    l.register("shop-the-look", eh),
    l.register("testimonials", ep),
    l.register("background-video", G),
    l.register("product", eo),
    l.register("product-recommendations", ea),
    l.register("collection", Q),
    l.register("article-list", R),
    l.register("article", z),
    l.register("faq", j),
    l.register("login", ei),
    l.register("addresses", F),
    l.register("gift-card", X),
    l.register("recently-viewed-products", er),
    l.register("shop-now", ec),
    (Flickity.defaults.dragThreshold = 7),
    (h = !1),
    document.body.addEventListener("touchstart", function (e) {
      if (e.target.closest(".flickity-slider")) h = !0;
      else {
        h = !1;
        return;
      }
      c = { x: e.touches[0].pageX, y: e.touches[0].pageY };
    }),
    document.body.addEventListener(
      "touchmove",
      function (e) {
        h &&
          e.cancelable &&
          Math.abs(
            { x: e.touches[0].pageX - c.x, y: e.touches[0].pageY - c.y }.x
          ) > Flickity.defaults.dragThreshold &&
          e.preventDefault();
      },
      { passive: !1 }
    ),
    (function () {
      if (window.Flickity) {
        var e = window.Flickity.prototype.resize,
          t = window.innerWidth;
        window.Flickity.prototype.resize = function () {
          (window.innerWidth !== t || !(this.maxCellHeight > 0)) &&
            ((t = window.innerWidth), e.apply(this, arguments));
        };
      }
    })(),
    g
      .nodeListToArray(document.querySelectorAll(".Rte table"))
      .forEach(function (e) {
        e.outerHTML = '<div class="TableWrapper">' + e.outerHTML + "</div>";
      }),
    g
      .nodeListToArray(document.querySelectorAll(".Rte iframe"))
      .forEach(function (e) {
        (-1 !== e.src.indexOf("youtube") ||
          -1 !== e.src.indexOf("youtu.be") ||
          -1 !== e.src.indexOf("vimeo")) &&
          ((e.outerHTML =
            '<div class="VideoWrapper">' + e.outerHTML + "</div>"),
          (e.src = e.src));
      }),
    (d = new domDelegate.Delegate(document.body)),
    (u = document.querySelector(".AnnouncementBar")),
    d.on("click", '[href^="#"], [data-href]', function (e, t) {
      var i = t.hasAttribute("href")
        ? t.getAttribute("href")
        : t.getAttribute("data-href");
      if ("#" !== i && "#main" !== i) {
        var n = document.querySelector(i),
          s = parseInt(t.getAttribute("data-offset") || 0);
        if (
          (u && (s -= u.clientHeight), t.hasAttribute("data-focus-on-click"))
        ) {
          var a = window.pageYOffset;
          n.focus({ preventScroll: !0 }),
            window.pageYOffset !== a && window.scrollTo(window.pageXOffset, a),
            n.focus();
        }
        window.scrollTo({ behavior: "smooth", top: n.offsetTop - s }),
          e.preventDefault();
      }
    }),
    (p = window.innerWidth),
    (m = document.getElementById("shopify-section-header")),
    window.addEventListener("resize", function () {
      var e = -1;
      fastdom.measure(function () {
        e = window.innerWidth;
      }),
        fastdom.mutate(function () {
          e !== p &&
            ((p = e),
            document.documentElement.style.setProperty(
              "--window-height",
              window.innerHeight + "px"
            ),
            m &&
              document.documentElement.style.setProperty(
                "--header-height",
                m.clientHeight + "px"
              ));
        });
    }),
    (function () {
      function e(t) {
        9 === t.keyCode &&
          (document.body.classList.add("is-tabbing"),
          window.removeEventListener("keydown", e));
      }
      window.addEventListener("keydown", e);
    })(),
    window.theme.showPageTransition && I.getInstance();
});
